import React, { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Box,
  Checkbox,
  CircularProgress,
  CssBaseline,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  LinearProgress,
  Radio,
  RadioGroup,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Switch,
  TextField as TextFieldMU,
  Typography,
  useMediaQuery
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { ModalAddGenerico } from 'src/components/modals/ModalAddGenerico'
import { ModalAddProcedimento } from 'src/components/modals/ModalAddProcedimento'
import AutocompleteOPME from 'src/components/OPME/AutocompleteOPME'
import {
  StepConnectorSyn,
  StepIconSyn
} from 'src/components/stepper/stepConnector'
import { StepContentSyn } from 'src/components/stepper/stepContentSyn'
import { Autocomplete } from 'src/components/ui/Autocomplete'
import DateInput from 'src/components/ui/DateInput'

import AutocompleteProcedimentos from 'src/components/ui/AutocompleteProcedimentos'
import { NumberFormatCustom } from 'src/components/ui/NumberField'
import { TextField } from 'src/components/ui/TextField'
import yup from 'src/components/yupCustom'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import { useQueryParams } from 'src/hooks/useQuery'
import {
  IPacoteDetalhadoResponse,
  ItemInternacao,
  ObjetoDescricaoGenerico,
  ObjetoDescricaoGenericoValor,
  ResumoMedicoResponse
} from 'src/types'
import Swal from 'sweetalert2'
import {
  obterEquipamentos,
  obterEspecialidades,
  obterListaOPME,
  obterLocaisAtendimento,
  obterMateriais,
  obterProcedimentos,
  obterTiposAnestesia
} from 'src/api/dominio'

import UBox from '../ui/Ubox'
import CurrencyInput from '../ui/CurrencyInput'
import TabelaOpme from './Form/tabelaOpme'
import TabelaMaterial from './Form/tabelaMaterial'
import TabelaExame from './Form/tabelaExame'
import INTERNACOES, { INTERNACOES_OBJ } from 'src/core/consts/internacoes'
import { buscarPorEspecialidades } from 'src/api/medico'
import { act } from 'react-dom/test-utils'
import {
  buscarParceiroPorId,
  obterFornecedoresPorLocalAtendimentoId,
  obterHorariosBaixoFluxoPorLocalAtendimentoId,
  obterTaxaOpmePorLocalAtendimentoId
} from 'src/api/parceiro'
import ResumoPacote from 'src/pages/dashboard/medico/pacote/resumo'
import ResumoPacoteInteligenteOps from './resumoOperacional'
import { boolean } from 'yup'
import {
  obterPacoteInteligentePorId,
  salvarPacoteInteligente,
  SalvarPacoteInteligenteCommand
} from 'src/api/pacoteInteligente'
import moment from 'moment'
import {
  ItemListagemMembroEquipe,
  MembroEquipeResponse
} from 'src/api/membroEquipe'
import StatusPacoteInteligente from 'src/core/consts/statusPacoteInteligente'
import { useQuery } from 'react-query'
import { obterTodasAcomodacoes, obterValorDiariaUti } from 'src/api/acomodacao'
import useAuth from 'src/hooks/useAuth'
import TabelaAcomodacao from './Form/tabelaAcomodacao'
import { SynPerfis } from 'src/core/consts/synPerfis'
// import { PERMISSAO_FINAL_SEMANA } from 'src/core/consts/permissaoFinaldeSemana'

interface EtapaConfiguracao {
  step: Steps
  validacao: string[]
  ativo: boolean
}

export enum Steps {
  especialidades = 'especialidades',
  observacao = 'observacao',
  medicos = 'medicos',
  pacote = 'pacote',
  seguro = 'seguro',
  valorBase = 'valorBase',
  descontos = 'descontos',
  opmeHospital = 'opmeHospital',
  opmeExterno = 'opmeExterno',
  anestesias = 'anestesias',
  equipamentos = 'equipamentos',
  materiais = 'materiais',
  internacoes = 'internacoes',
  dataExpiracao = 'dataExpiracao',
  reservaSangue = 'reservaSangue',
  revisao = 'revisao'
}

const useStyles = makeStyles(theme => ({
  container: {},
  inputIcon: { color: theme.palette.grey[500] },
  form: { width: '100%' },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(1)
  },
  subTitle: {
    padding: theme.spacing(3, 0, 0, 0)
  },
  infoTxt: {
    color: theme.palette.info.light
  },
  noMargin: {
    margin: theme.spacing(0)
  },
  [theme.breakpoints.down('sm')]: {
    container: {
      margin: '0 auto',
      boxShadow: 'none'
    }
  }
}))

export interface ItemOpmeInteligente {
  id?: string
  descricao: string
  valorUnitario: number
  fornecedor: ObjetoDescricaoGenerico
  fornecedorId?: string
  hospitalFornece?: boolean
  valido?: boolean

  quantidade?: number
  quantidadeIncluso?: number
  selecionado?: boolean
  podeAcrescentar?: boolean
  podeSubtrair?: boolean
}

export interface ItemAcomodacaoInteligente {
  id?: string
  descricao: string
  valor: number
  ativo: boolean
  padrao: boolean
  valido?: boolean
}

export interface ItemMaterialInteligente {
  id?: string
  descricao: string
  valorUnitario: number
  valido?: boolean

  selecionado?: boolean
  quantidade?: number
  quantidadeIncluso?: number
  podeAcrescentar?: boolean
  podeSubtrair?: boolean
}

export interface IPacoteInteligenteForm {
  id?: string
  observacao?: string

  origemPacote: string
  uf?: ObjetoDescricaoGenerico
  hospital: ObjetoDescricaoGenerico
  //step2
  especialidades: ObjetoDescricaoGenerico[]
  //step3
  pacotePublico?: boolean
  listaMedico: any[]
  //step4
  descricao: string
  procedimentos: ObjetoDescricaoGenericoValor[]
  valorBase?: number
  taxaSyn?: number
  possuiTaxaSynPersonalizada?: boolean

  propostaCentroCirurgicoAmbulatorial?: boolean
  descontoCentroCirurgicoAmbulatorial?: number
  propostaBaixoFluxo?: boolean
  propostaCartaoDesconto?: boolean
  descontoCartao?: number
  propostaDiasUteis?: boolean
  descontoBaixoFluxo?: number
  planoDeSaude?: boolean
  //step5
  possuiOpmeTerceiro?: boolean
  medicoInformaOpme?: boolean
  possuiMaterial?: boolean
  opmesInclusos?: ItemOpmeInteligente[]
  opmes?: ItemOpmeInteligente[]

  taxaOpme: number
  //step6
  tiposAnestesia: ObjetoDescricaoGenericoValor[]
  responsavelAnestesia: string
  possuiAnestesista?: boolean
  semAnestesia?: boolean
  permiteAnestesiaExterna?: boolean
  permiteSolicitacaoSemPaciente?: boolean
  valorEquipeAnestesia?: number

  //step7
  equipamentos: ObjetoDescricaoGenericoValor[]
  membros?: ItemListagemMembroEquipe[]
  //step8
  materiais: ItemMaterialInteligente[]
  //step9
  valoresInternacao: ItemInternacao[]
  acomodacoes?: ItemAcomodacaoInteligente[]
  //step10
  dataExpiracao: string
  data?: string
  //step11
  possuiSangue?: boolean
  valorTaxaReservaSangue: number
  valorUnidadeConcentradoHemacias: number
  examesDuranteInternacao: ItemMaterialInteligente[]

  //Configuração
  configurado?: boolean
  semHonorarioMedico?: boolean
  semHonorarioAnestesista?: boolean
  diariasUti?: number
  diariasInternacao?: number
  honorarioEquipeMedica?: number

  dayClinic?: boolean
  pqa?: boolean
  mediaTempoCirurgico?: string
  reservaSangue?: number
  status?: number

  podeFinalSemana?: boolean
  podeAmbulatorio?: boolean

  //listagem
  listaOpmesDisponiveis?: ItemOpmeInteligente[]
  podeBaixoFluxo?: boolean
  podeDiasUteis?: boolean
  podeCentroCirurgicoAmbulatorial?: boolean
  podeCartaoDesconto?: boolean
  temPlanoDeSaude?: boolean

  aceitaSeguro?: boolean
  idadeMinimaSeguro?: number
  idadeMaximaSeguro?: number

  pendencias?: {
    etapa: string
    possuiPendencia: boolean
    comentario: string
  }[]
}

export interface IPermissaoFinalSemana {
  id: number
  descricao: string
  ativo: boolean
  valor?: number
}

export function mapearPacoteParaRequest(
  form: IPacoteInteligenteForm,
  possuiExpiracao: boolean,
  semAnestesia: boolean,
  possuiAnestesista: boolean
  // propostaCentroCirurgicoAmbulatorial: boolean,
  // propostaBaixoFluxo: boolean
) {
  let pacote: SalvarPacoteInteligenteCommand = Object.assign({}, form) as any

  var formulario: IPacoteInteligenteForm = JSON.parse(JSON.stringify(form))
  pacote.planoDeSaude = formulario.planoDeSaude

  pacote.hospitalId = formulario.hospital.id

  pacote.valorTaxaReservaSangue = formulario.valorTaxaReservaSangue / 100
  pacote.valorUnidadeConcentradoHemacias =
    formulario.valorUnidadeConcentradoHemacias / 100

  if (!formulario.possuiSangue) {
    pacote.valorTaxaReservaSangue = null
    pacote.valorUnidadeConcentradoHemacias = null
  }

  pacote.opmesInclusos = formulario.opmesInclusos.map(i => {
    i.valorUnitario = i.valorUnitario / 100
    return i
  })

  pacote.opmes = formulario.opmes.map(i => {
    i.valorUnitario = i.valorUnitario / 100
    i.fornecedorId = i?.fornecedor?.id
    return i
  })

  pacote.especialidades = formulario.especialidades.map(i => i.id)
  pacote.procedimentos = formulario.procedimentos
  pacote.listaMedico = formulario.pacotePublico
    ? null
    : formulario.listaMedico.map(i => i.id)

  pacote.taxaOpme = formulario.taxaOpme / 100

  pacote.semAnestesia = semAnestesia
  pacote.possuiAnestesista = possuiAnestesista

  if (semAnestesia) {
    pacote.tiposAnestesia = []
  } else {
    pacote.tiposAnestesia = formulario.tiposAnestesia.map(i => {
      i.valor = i.valor / 100
      return i
    })
  }

  pacote.equipamentos = formulario.equipamentos.map(i => {
    i.valor = i.valor / 100
    return i
  })

  pacote.valoresInternacao = formulario?.valoresInternacao?.map(i => {
    i.valor = i.valor / 100
    i.valorApartamento = i.valorApartamento / 100
    return i
  })

  pacote.acomodacoes = formulario?.acomodacoes?.map(a => {
    a.valor = a.valor / 100
    return a
  })

  pacote.materiais = formulario?.materiais?.map(i => {
    i.valorUnitario = i.valorUnitario / 100
    return i
  })

  pacote.examesDuranteInternacao = formulario.examesDuranteInternacao.map(i => {
    i.valorUnitario = i.valorUnitario / 100
    return i
  })

  if (!!formulario.possuiTaxaSynPersonalizada) {
    pacote.taxaSynPersonalizada = formulario.taxaSyn / 100
  }

  pacote.dataExpiracao =
    !possuiExpiracao && !formulario.dataExpiracao
      ? null
      : formulario.dataExpiracao
  pacote.valorBase = formulario.valorBase / 100
  pacote.descontoCentroCirurgicoAmbulatorial =
    formulario.descontoCentroCirurgicoAmbulatorial / 100
  pacote.descontoBaixoFluxo = formulario.descontoBaixoFluxo / 100

  pacote.descontoCartao = formulario.descontoCartao / 100

  // pacote.propostaCentroCirurgicoAmbulatorial = propostaCentroCirurgicoAmbulatorial

  // pacote.propostaBaixoFluxo = propostaBaixoFluxo

  pacote.aceitaSeguro = formulario.aceitaSeguro
  if (formulario.aceitaSeguro) {
    pacote.idadeMinimaSeguro = formulario.idadeMinimaSeguro
    pacote.idadeMaximaSeguro = formulario.idadeMaximaSeguro
  } else {
    pacote.idadeMinimaSeguro = null
    pacote.idadeMaximaSeguro = null
  }

  pacote.pendencias = (formulario.pendencias || []).map(p => ({
    etapa: p.etapa,
    possuiPendencia: p.possuiPendencia,
    comentario: p.comentario || ''
  }))

  return pacote
}

type Props = {
  pacote?: IPacoteInteligenteForm
  etapaAjuste?: Steps
  handleSalvarAjuste?: (dados: IPacoteInteligenteForm) => void
}

export const anestesiaLocalId = 'f275e81c-0806-4a76-970a-eb34e4a5cbfd'
let ehPacoteLiberado = false
function FormPacoteInteligente(props: Props) {
  const { user, tenantAtual, perfilAtual } = useAuth()
  const [possuiExpiracao, setPossuiExpiracao] = useState(false)
  let etapasFormularioDefault: EtapaConfiguracao[] = [
    { step: Steps.especialidades, validacao: ['especialidades'], ativo: true },
    { step: Steps.observacao, validacao: [], ativo: true },
    {
      step: Steps.medicos,
      validacao: ['pacotePublico', 'listaMedico'],
      ativo: true
    },
    {
      step: Steps.pacote,
      validacao: ['descricao', 'procedimentos'],
      ativo: true
    },
    {
      step: Steps.seguro,
      validacao: ['aceitaSeguro', 'idadeMinimaSeguro', 'idadeMaximaSeguro'],
      ativo: true
    },
    { step: Steps.valorBase, validacao: [], ativo: true },
    {
      step: Steps.descontos,
      validacao: [
        'descontoCentroCirurgicoAmbulatorial',
        'descontoBaixoFluxo',
        'descontoCartao'
      ],
      ativo: true
    },
    { step: Steps.opmeHospital, validacao: [], ativo: true },
    { step: Steps.opmeExterno, validacao: [], ativo: false },
    { step: Steps.anestesias, validacao: [], ativo: true },
    { step: Steps.equipamentos, validacao: [], ativo: true },
    { step: Steps.materiais, validacao: [], ativo: true },
    { step: Steps.internacoes, validacao: [], ativo: true },
    {
      step: Steps.dataExpiracao,
      validacao: [],
      ativo: true
    },
    { step: Steps.reservaSangue, validacao: [], ativo: true },
    { step: Steps.revisao, validacao: [], ativo: true }
  ]
  const [etapasFormulario, setEtapasFormulario] = useState(
    etapasFormularioDefault
  )

  let ehHospital = [
    SynPerfis.ADMIN_HOSPITAL,
    SynPerfis.OPERACIONAL_HOSPITAL
  ].includes(perfilAtual)
  const query = useQueryParams()
  const ehEdicao = query.get('idPacote')
  const [propostaBaixoFluxo, setPropostaBaixoFluxo] = useState(false)
  const [propostaCartaoDesconto, setPropostaCartaoDesconto] = useState(false)
  const [
    propostaCentroCirurgicoAmbulatorial,
    setPropostaCentroCirurgicoAmbulatorial
  ] = useState(false)

  //#region SCHEMA
  const schema = yup.object().shape({
    origemPacote: yup.string().required().label('Origem do pacote'),
    hospital: yup.object().nullable().required().label('Hospital'),
    //step2
    especialidades: yup.array().min(1).required().label('Especialidades'),
    //step3
    planoDeSaude: yup.bool().required().label('Aprovação do hospital'),
    pacotePublico: yup.bool().required().label('Pacote público'),
    listaMedico: yup
      .array()
      .nullable()
      .when('pacotePublico', {
        is: pacotePublico => !pacotePublico,
        then: yup.array().min(1).required().label('Médicos')
      }),
    //step4
    descricao: yup.string().required().label('Nome do pacote'),
    aceitaSeguro: yup.bool().nullable().required('Defina se o pacote aceita seguro'),
    idadeMinimaSeguro: yup
      .number()
      .nullable()
      .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
      .when('aceitaSeguro', {
        is: (aceitaSeguro) => aceitaSeguro === true,
        then: yup
          .number()
          .min(0, 'Idade mínima não pode ser menor que 0')
          .required('Idade mínima obrigatória')
          .typeError('Idade deve ser um número')
          .label('Idade mínima')
      }),
    idadeMaximaSeguro: yup
      .number()
      .nullable()
      .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
      .when('aceitaSeguro', {
        is: (aceitaSeguro) => aceitaSeguro === true,
        then: yup
          .number()
          .required('Idade máxima obrigatória')
          .typeError('Idade deve ser um número')
          .label('Idade máxima')
      }),
    //step4
    descontoBaixoFluxo: yup.number().when('propostaBaixoFluxo', {
      is: () => !!propostaBaixoFluxo,
      then: yup
        .number()
        .moreThan(0)
        .required()
        .label('Desconto para Horários de baixo fluxo')
    }),
    descontoCentroCirurgicoAmbulatorial: yup
      .number()
      .when('propostaCentroCirurgicoAmbulatorial', {
        is: () => !!propostaCentroCirurgicoAmbulatorial,
        then: yup
          .number()
          .moreThan(0)
          .required()
          .label('Desconto para centro cirúrgico ambulatorial')
        // .label('Valor obrigatório para centro cirúrgico ambulatorial')
      }),
    descontoCartao: yup.number().when('propostaCartaoDesconto', {
      is: () => !!propostaCartaoDesconto,
      then: yup
        .number()
        .moreThan(0)
        .required()
        .label('Desconto para cartão de desconto')
      // .label('Valor obrigatório para centro cirúrgico ambulatorial')
    }),
    procedimentos: yup.array().min(1).required().label('Procedimentos'),
    //
    //step5
    opmes: yup.array().label('Lista de OPME'),
    taxaOpme: yup.string().nullable().required().label('Taxa de OPME'),
    //step6
    tiposAnestesia: yup.array().min(0).label('Tipo de anestesia'),
    responsavelAnestesia: yup.string().label('Responsável pela anestesia'),
    //step7
    equipamentos: yup.array().label('Equipamentos hospitalares'),
    //step8
    materiais: yup.array().label('Materiais hospitalares'),
    //step9
    valoresInternacao: yup.array().label('Valores internacao'),
    acomodacoes: yup.array().label('Acomodações'),
    //step10
    dataExpiracao: yup
      .string()
      .test('data-exp-teste', 'data de expiração inválida', value => {
        if (!value) return false

        var dataValida = moment(value, 'YYYY-MM-DD')
        var hoje = moment()

        return dataValida > hoje
      })
      .required()
      .label('Data de expiração'),
    //step11
    valorTaxaReservaSangue: yup
      .string()
      .nullable()
      .required()
      .label('Taxa reserva de sangue'),
    valorUnidadeConcentradoHemacias: yup
      .string()
      .nullable()
      .required()
      .label('Concentrado de hemácias'),
    examesDuranteInternacao: yup.array().min(0).label('Exames')
  })
  //#endregion

  const classes = useStyles()
  const history = useHistory()
  //#region Definicao de listas e loading
  const [loading, setLoading] = useState(true)
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const [locaisAtendimentos, setLocaisAtendimentos] = useState<
    ObjetoDescricaoGenerico[]
  >([])

  const [listaUf, setListaUf] = useState<ObjetoDescricaoGenerico[]>([])
  const [
    loadingLocaisAtendimentos,
    setLoadingLocaisAtendimentos
  ] = useState<boolean>(true)

  const [especialidades, setEspecialidades] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [loadingEspecialidades, setLoadingEspecialidades] = useState<boolean>(
    true
  )

  const [listaProcedimentos, setListaProcedimentos] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [loadingProcedimentos, setLoadingProcedimentos] = useState<boolean>(
    true
  )

  const [listaMedicos, setListaMedicos] = useState<ResumoMedicoResponse[]>([])
  const [loadingMedicos, setLoadingMedicos] = useState<boolean>(true)

  const [listaFornecedores, setListaFornecedores] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [loadingFornecedores, setLoadingFornecedores] = useState<boolean>(true)
  const [horariosBaixoFluxo, setHorariosBaixoFluxo] = useState<string | null>(
    null
  )

  const [listaTiposAnestesia, setListaTiposAnestesia] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [loadingTiposAnestesia, setLoadingTiposAnestesia] = useState<boolean>(
    true
  )

  const [semAnestesia, setSemAnestesia] = useState<boolean>(false)
  const [possuiAnestesista, setPossuiAnestesista] = useState<boolean>(false)
  const [
    obrigatorioAnestesiaHospital,
    setObrigatorioAnestesiaHospital
  ] = useState<boolean>(false)

  const [listaOPME, setListaOPME] = useState<ObjetoDescricaoGenerico[]>([])
  const [loadingOPME, setLoadingOPME] = useState<boolean>(true)

  const [listaEquipamentos, setListaEquipamentos] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [listaMateriais, setListaMateriais] = useState<
    ObjetoDescricaoGenerico[]
  >([])

  const [loadingEquipamentos, setLoadingEquipamentos] = useState<boolean>(true)
  const [showUTIDays, setShowUTIDays] = useState<boolean>(false)
  const [valorDiariaUtiPadrao, setValorDiariaUtiPadrao] = useState<number>(0)

  //#endregion
  const [pacote, setPacote] = useState<IPacoteInteligenteForm>()
  const [ajustePacote, setAjustePacote] = useState(false)

  const [textoModal, setTextoModal] = useState('')
  const [showModal, toggleModal] = useState<string>(null)

  const [showModalProcedimento, toggleModalProcedimento] = useState(false)
  const handleShowModal = (texto, modal) => {
    setTextoModal(texto)
    toggleModal(modal)
  }

  const [defaultCheckedRadio, setDefaultCheckedRadio] = useState('H')

  const handleShowModalProcedimento = (texto: string) => {
    setTextoModal(texto)
    toggleModalProcedimento(true)
  }

  var perfilTenantAtual = user?.perfisPorTenant?.find(
    p => p.tenantId === tenantAtual
  )
  //#region Formulário
  const defaultValues: IPacoteInteligenteForm = {
    origemPacote: 'H', //M- médico | H - hospital
    hospital: {
      descricao: perfilTenantAtual?.descricao,
      id: perfilTenantAtual?.localAtendimentoId
    },
    observacao: '',
    //step2
    especialidades: [], // ObjetoDescricaoGenerico[]
    //step3
    pacotePublico: true,
    planoDeSaude: false,

    listaMedico: [],
    descontoBaixoFluxo: 0,
    descontoCentroCirurgicoAmbulatorial: 0,
    descontoCartao: 0,
    propostaBaixoFluxo: false,
    propostaCentroCirurgicoAmbulatorial: false,
    propostaCartaoDesconto: false,
    //step4
    descricao: '',
    procedimentos: [],
    valorBase: 0,
    //step5
    opmesInclusos: [],
    opmes: [],
    possuiOpmeTerceiro: false,
    taxaOpme: 0,
    medicoInformaOpme: false,
    possuiTaxaSynPersonalizada: false,
    semHonorarioMedico: false,
    semHonorarioAnestesista: false,
    //step6
    tiposAnestesia: [],
    responsavelAnestesia: '',
    //step7
    equipamentos: [],
    //step8
    possuiMaterial: false,
    materiais: [],
    //step9
    valoresInternacao: [],
    acomodacoes: [],
    //step10
    dataExpiracao: '',
    data: '',
    //step11
    possuiSangue: false,
    valorTaxaReservaSangue: 0,
    valorUnidadeConcentradoHemacias: 0,
    examesDuranteInternacao: [],
    reservaSangue: 0,
    pendencias: []
  }

  const {
    watch,
    register,
    setValue,
    errors,
    control,
    formState,
    handleSubmit,
    trigger
  } = useForm<IPacoteInteligenteForm>({
    mode: 'all',
    resolver: yupResolver(schema),
    defaultValues: defaultValues
  })

  const command = watch()

  // REGISTRA VALORES REACT FORM HOOKS
  useEffect(() => {
    register('id')
    register('uf')
    register('origemPacote')
    register('hospital')
    register('especialidades')
    register('pacotePublico')
    register('listaMedico')

    register('planoDeSaude')
    register('aceitaSeguro')

    register('procedimentos')
    register('valorBase')

    register('possuiOpmeTerceiro')
    register('medicoInformaOpme')

    register('taxaOpme')
    register('opmes')
    register('opmesInclusos')
    register('tiposAnestesia')
    register('responsavelAnestesia')

    register('propostaBaixoFluxo')
    register('propostaCentroCirurgicoAmbulatorial')
    register('descontoCentroCirurgicoAmbulatorial')
    register('descontoBaixoFluxo')
    register('propostaCartaoDesconto')
    register('descontoCartao')

    register('taxaSyn')
    register('possuiTaxaSynPersonalizada')

    register('equipamentos')
    register('materiais')
    register('possuiMaterial')
    register('valoresInternacao')
    register('acomodacoes')

    register('dataExpiracao')
    register('data')
    register('valorTaxaReservaSangue')
    register('valorUnidadeConcentradoHemacias')

    register('possuiSangue')
    register('examesDuranteInternacao')
    register('reservaSangue')

    register('semHonorarioMedico')
    register('semHonorarioAnestesista')
    register('observacao')
    register('pendencias')
  }, [register])

  function handleChangeValor(key: keyof IPacoteInteligenteForm, valor: number) {
    let valorFormatado = valor / 100
    if (!valorFormatado || valorFormatado < 0) {
      valor = 0
    }

    // return valorFormatado
    setValue(key, valor, { shouldValidate: true })
  }

  function handleChangeValorAnestesia(index: number, valor: number) {
    let valorFormatado = valor / 100
    if (!valorFormatado || valorFormatado < 0) {
      valor = 0
    }

    var novoValor = command?.tiposAnestesia[index]
    novoValor['valor'] = valor
    command.tiposAnestesia[index] = novoValor
    var anestesias = command.tiposAnestesia
    // return valorFormatado
    setValue('tiposAnestesia', anestesias, { shouldValidate: true })
  }

  // VINCULAR MUDANÇA DE VALOR
  const handleItemValue = (name: keyof IPacoteInteligenteForm, item) => {
    setValue(name, item, {
      shouldValidate: true
    })
  }

  const handleItemValueEquipamentos = item => {
    var novoItem = JSON.parse(JSON.stringify(item))

    novoItem.valorIncluso = true
    novoItem.valor = novoItem.valor * 100
    var equipamento = command?.equipamentos?.find(e => e?.id === novoItem?.id)

    var novaLista = command?.equipamentos
    //remove
    if (equipamento) {
      novaLista = novaLista.filter(e => e.id !== novoItem.id)
    } else {
      //add
      novaLista = [...novaLista, novoItem]
    }

    setValue('equipamentos', novaLista, {
      shouldValidate: true
    })
  }

  const handleItemValueInternacao = (item: ItemInternacao) => {
    item.valor = 0
    item.valorIncluso = false
    item.quantidadeIncluso = 0
    item.podeAcrescentar = false
    item.podeSubtrair = false
    item.apartamento = false
    item.valorApartamento = 0

    var internacao = command?.valoresInternacao?.find(e => e?.id === item?.id)

    var novaLista = command?.valoresInternacao
    //remove
    if (internacao) {
      novaLista = novaLista.filter(e => e.id !== item.id)
    } else {
      //add
      novaLista = [...novaLista, item]
    }

    setValue('valoresInternacao', novaLista, {
      shouldValidate: true
    })
  }

  const handleItemKeyInternacao = (
    item: ItemInternacao,
    valor,
    key: keyof ItemInternacao
  ) => {
    let internacoes = command?.valoresInternacao

    let indexA = internacoes.findIndex(e => e.id === item.id)

    // if (valor) {
    //   internacoes[indexA].valor = 0
    // }

    let i = internacoes[indexA]

    i[key as string] = valor

    if (
      (key === 'podeAcrescentar' || key === 'podeSubtrair') &&
      valor === true &&
      item.id === INTERNACOES_OBJ.UTI.id
    ) {
      if (!i.valor) {
        i.valor = valorDiariaUtiPadrao
      }
    }

    handleItemValue('valoresInternacao', internacoes)
  }

  function obterAnestesiaSelecionada(descricao: string) {
    var x = command?.tiposAnestesia.find(i => descricao === i?.descricao)
    return x
  }

  function obterEquipamentoSelecionadoPorId(id: string) {
    var x = command?.equipamentos.find(e => id === e?.id)
    return x
  }

  function obterInternacaoSelecionadaPorId(id: string) {
    var internacoes = command?.valoresInternacao.find(e => id === e?.id)
    return internacoes
  }

  const handleChangeItemValueEquipamento = (
    item: any,
    key: string,
    value: any
  ) => {
    var equipamento = command?.equipamentos?.find(e => e?.id === item?.id)

    var novaLista = command?.equipamentos
    //altera
    if (equipamento) {
      equipamento[key] = value
      novaLista = novaLista.filter(e => e.id !== item.id)

      novaLista = [...novaLista, equipamento]
      setValue('equipamentos', novaLista, {
        shouldValidate: true
      })
    }
  }

  const handleChangeItemValueInternacao = (
    item: any,
    key: string,
    value: any
  ) => {
    var internacao = command?.valoresInternacao?.find(e => e?.id === item?.id)

    var novaLista = command?.valoresInternacao
    //altera
    if (internacao) {
      internacao[key] = value
      novaLista = novaLista.filter(e => e.id !== item.id)

      novaLista = [...novaLista, internacao]
      setValue('valoresInternacao', novaLista, {
        shouldValidate: true
      })
    }
  }

  const handleRadios = e => {
    let valueRadio = e.target.value
    handleItemValue('hospital', null)
    handleItemValue('origemPacote', valueRadio)
  }

  const handleRadiosOpme = e => {
    let valueRadio = e.target.value

    handleItemValue('opmes', [])
    handleItemValue('possuiOpmeTerceiro', valueRadio === 'true')
  }

  const handleRadiosPropFinalSemana = e => {
    let valueRadio = e.target.value

    handleItemValue('propostaBaixoFluxo', valueRadio === 'true')
    if (valueRadio === 'true') {
      setPropostaBaixoFluxo(true)
    }

    if (valueRadio !== 'true') {
      handleItemValue('descontoBaixoFluxo', 0)
      setPropostaBaixoFluxo(false)
    }
  }

  const handleRadiosPropCartaoDesconto = e => {
    let valueRadio = e.target.value

    handleItemValue('propostaCartaoDesconto', valueRadio === 'true')

    if (valueRadio === 'true') {
      setPropostaCartaoDesconto(true)
    }

    if (valueRadio !== 'true') {
      handleItemValue('descontoCartao', 0)
      setPropostaCartaoDesconto(false)
    }
  }

  const handleRadiosPropCentroCirurgico = e => {
    let valueRadio = e.target.value

    handleItemValue(
      'propostaCentroCirurgicoAmbulatorial',
      valueRadio === 'true'
    )

    if (valueRadio === 'true') {
      setPropostaCentroCirurgicoAmbulatorial(true)
    }

    if (valueRadio !== 'true') {
      setPropostaCentroCirurgicoAmbulatorial(false)
      handleItemValue('descontoCentroCirurgicoAmbulatorial', 0)
    }
  }

  const handleRadiosTaxaSyn = e => {
    let valueRadio = e.target.value

    handleItemValue('taxaSyn', null)
    handleItemValue('possuiTaxaSynPersonalizada', valueRadio === 'true')
  }

  const handleRadiosAprovacaoHospital = e => {
    let valueRadio = e.target.value
    handleItemValue('planoDeSaude', valueRadio === 'true')
  }

  const handleRadiosAceitaSeguro = e => {
    let valueRadio = e.target.value
    handleItemValue('aceitaSeguro', valueRadio === 'true')
  }

  const handleRadiosSangue = e => {
    let valueRadio = e.target.value

    handleItemValue('possuiSangue', valueRadio === 'true')
  }

  const handleRadiosExpiracao = e => {
    let valueRadio = e.target.value

    handleItemValue('dataExpiracao', '')
    setPossuiExpiracao(valueRadio === 'true')
  }

  const handleMedicoInformaOpme = value => {
    handleItemValue('opmes', [])
    handleItemValue('medicoInformaOpme', value)
  }

  const handleRadiosMaterial = e => {
    let valueRadio = e.target.value

    handleItemValue('materiais', [])
    handleItemValue('possuiMaterial', valueRadio === 'true')
  }

  const handleRadiosResponsavelAnestesia = e => {
    let valueRadio = e.target.value

    // handleItemValue('opmes', [])
    handleItemValue('responsavelAnestesia', valueRadio)
  }

  const handleRadiosPacotePublico = e => {
    let valueRadio = e.target.value

    handleItemValue('listaMedico', [])
    handleItemValue('pacotePublico', valueRadio === 'true')
  }

  const getDefaultCheckedRadio = pacote => {
    pacote.pqa && setDefaultCheckedRadio('pqa')
    pacote.dayClinic && setDefaultCheckedRadio('dayClinic')
    !pacote.pqa &&
      !pacote.dayClinic &&
      setDefaultCheckedRadio('withInternation')

    !pacote.pqa && !pacote.dayClinic && setShowUTIDays(true)
  }

  const handleNovoValor = (name, item: any) => {
    switch (name) {
      case 'equipamentos':
        carregarEquipamentos()
        setValue('equipamentos', [...command.equipamentos, item], {
          shouldValidate: true
        })
        break
      case 'materiais':
        carregarMateriais()
        setValue('materiais', [...command.materiais, item], {
          shouldValidate: true
        })
        break
      case 'tiposAnestesia':
        carregarTiposAnestesia()
        setValue('tiposAnestesia', [...command.tiposAnestesia, item], {
          shouldValidate: true
        })
        break
      case 'opmesInclusos':
        carregarOPME()
        item.quantidade = 1
        setValue('opmes', [...command.opmesInclusos, item], {
          shouldValidate: true
        })
        break
      case 'procedimento':
        carregarProcedimentos()
        setValue('procedimento', item, {
          shouldValidate: true
        })
        break
    }
  }
  //#endregion

  async function carregarValorUtiPadrao() {
    try {
      var response = await obterValorDiariaUti()
      if (response.data && response.data.valor) {
        setValorDiariaUtiPadrao(parseFloat(response.data.valor) * 100)
      }
    } catch (error) {}
  }

  //#region MOUNT
  useEffect(() => {
    carregarValorUtiPadrao()
    carregarLocaisAtendimentos()
    carregarEspecialidades()
    carregarProcedimentos()
    carregarTiposAnestesia()
    carregarOPME()
    carregarEquipamentos()
    carregarMateriais()
    const ehAjuste = verificaEhAjuste()
    if (!ehAjuste) verificaEhEdicao()
  }, [])

  const { data: acomodacoes, isLoading, error, isError, refetch } = useQuery(
    ['acomodacoes', user?.id],
    async () => {
      var response = await obterTodasAcomodacoes()
      return response.data
    },
    {
      onSuccess: data => {
        const id = query.get('idPacote')

        if (!id) {
          let lista = data?.map(i => {
            i.valor = i.valor * 100
            var novo: ItemAcomodacaoInteligente = i
            novo.valido = true
            novo.valor = i.valor
            return i
          })

          setValue('acomodacoes', lista)
        }
      },
      cacheTime: 1 * (1000 * 60) //1 minuto
    }
  )

  const { data: parceiro, isLoading: isLoadingParceiro } = useQuery(
    ['parceiro', user?.id],
    async () => {
      var response = await buscarParceiroPorId(perfilTenantAtual?.parceiroId)
      return response.data
    },
    {
      onSuccess: parceiro => {
        if (
          perfilAtual === SynPerfis.OPERACIONAL ||
          perfilAtual === SynPerfis.SUPER_ADMIN ||
          parceiro.gerenciarOpmeExterno
        ) {
          var indexOpmeExterno = etapasFormulario.findIndex(
            i => i.step === Steps.opmeExterno
          )
          var opmeExterno = etapasFormulario[indexOpmeExterno]
          opmeExterno.ativo = true

          setEtapasFormulario(etapasFormulario)
        }

        if (!parceiro.permiteEquipeAnestesiaExterna) {
          setPossuiAnestesista(true)
          setObrigatorioAnestesiaHospital(true)
        }
      },
      cacheTime: 1 * (1000 * 60) //5 minuto
    }
  )

  useEffect(() => {
    if (!!acomodacoes && !!pacote?.acomodacoes) {
      var acomodacoesPacote = acomodacoes.map(acomodacao => {
        var acomodacaoConfigurada = pacote.acomodacoes.find(
          a => a.id === acomodacao.id
        )

        acomodacao.valor = acomodacao.valor * 100

        if (acomodacaoConfigurada) {
          acomodacao.padrao = acomodacaoConfigurada.padrao
          acomodacao.ativo = true
          acomodacao.valor = acomodacaoConfigurada.valor
        } else {
          acomodacao.ativo = false
          acomodacao.padrao = false
        }

        return acomodacao
      })
      setValue('acomodacoes', acomodacoesPacote)
    }
  }, [acomodacoes, pacote?.acomodacoes])

  function verificaEhAjuste() {
    if (props.pacote !== undefined && props.etapaAjuste !== undefined) {
      getDefaultCheckedRadio(props.pacote)

      for (const key in props.pacote) {
        setValue(key, props.pacote[key], { shouldValidate: false })
      }

      setAjustePacote(true)
      setActiveStep(props.etapaAjuste)
      setLoading(false)

      return true
    }

    return false
  }

  function verificaEhEdicao() {
    const id = query.get('idPacote')

    if (!id) {
      setLoading(false)
      return
    }

    obterPacoteInteligentePorId(id)
      .then(response => {
        const pacote = response.data
        montarPacote(pacote)
        // carregarOpcoes(pacote)
        setLoading(false)
      })
      .catch(e => {
        showNotificationErrorAPI(e)
        history.goBack()
      })
  }

  function montarPacote(pacote: IPacoteInteligenteForm) {
    // setPacote(pacote)
    pacote.descontoCentroCirurgicoAmbulatorial =
      pacote.descontoCentroCirurgicoAmbulatorial * 100

    pacote.descontoCartao = pacote.descontoCartao * 100
    pacote.descontoBaixoFluxo = pacote.descontoBaixoFluxo * 100

    pacote.valorBase = pacote.valorBase * 100

    pacote.opmes = pacote?.opmes.map(i => {
      i.valorUnitario = i.valorUnitario * 100
      i.valido = true
      return i
    })

    pacote.uf = {
      id: pacote?.hospital?.grupo,
      descricao: pacote?.hospital?.grupo
    }

    pacote.opmesInclusos = pacote?.opmesInclusos.map(i => {
      i.valorUnitario = i.valorUnitario * 100
      i.valido = true
      return i
    })
    pacote.materiais = pacote?.materiais.map(i => {
      i.valorUnitario = i.valorUnitario * 100
      i.valido = true
      return i
    })

    pacote.valorTaxaReservaSangue = pacote?.valorTaxaReservaSangue * 100
    pacote.valorUnidadeConcentradoHemacias =
      pacote?.valorUnidadeConcentradoHemacias * 100

    pacote.taxaOpme = pacote?.taxaOpme * 100
    pacote.tiposAnestesia = pacote?.tiposAnestesia.map(i => {
      i.valor = i.valor * 100
      return i
    })

    pacote.equipamentos = pacote?.equipamentos.map(i => {
      i.valor = i.valor * 100
      i.valido = true
      return i
    })

    pacote.valoresInternacao = pacote?.valoresInternacao.map(i => {
      i.valor = i?.valor * 100
      i.valorApartamento = i?.valorApartamento * 100
      return i
    })

    pacote.examesDuranteInternacao = pacote?.examesDuranteInternacao.map(i => {
      i.valorUnitario = i.valorUnitario * 100
      i.valido = true
      return i
    })

    if (pacote.taxaSyn !== null) {
      pacote.possuiTaxaSynPersonalizada = true
      pacote.taxaSyn = pacote.taxaSyn * 100
    }

    if (!!pacote.valorTaxaReservaSangue) {
      pacote.possuiSangue = true
    }

    pacote.acomodacoes = (pacote.acomodacoes || [])?.map(i => {
      let novo: ItemAcomodacaoInteligente = i
      novo.valor = i.valor * 100
      novo.ativo = true
      novo.valido = true
      return i
    })

    setPossuiAnestesista(pacote?.possuiAnestesista)
    setSemAnestesia(pacote?.semAnestesia)
    setPossuiExpiracao(!!pacote?.dataExpiracao)

    for (const key in pacote) {
      setValue(key, pacote[key], { shouldValidate: false })
    }

    if (pacote.status === StatusPacoteInteligente.DISPONIVEL_SOLICITACAO.Id) {
      setActiveStep(Steps.especialidades)
    }

    setPacote(pacote)
    // obterFornecedoresOpme(pacote?.hospital.id)
    // getDefaultCheckedRadio(pacote)
  }
  //#endregion

  //#region Carregar Opções do Sistema
  const carregarLocaisAtendimentos = async () => {
    return obterLocaisAtendimento()
      .then(response => {
        var ufs = response.data.map(i => i.grupo)
        let ufsDistintas = [...new Set(ufs)]
          .filter(i => !!i)
          .map(i => {
            return { id: i, descricao: i }
          })
        setListaUf(ufsDistintas || [])
        setLocaisAtendimentos(response.data || [])
      })
      .finally(() => {
        setLoadingLocaisAtendimentos(false)
      })
  }

  async function carregarEspecialidades() {
    return obterEspecialidades()
      .then(response => setEspecialidades(response.data))
      .finally(() => {
        setLoadingEspecialidades(false)
      })
  }

  const carregarProcedimentos = async () => {
    return obterProcedimentos()
      .then(response => setListaProcedimentos(response.data || []))
      .finally(() => {
        setLoadingProcedimentos(false)
      })
  }

  const carregarTiposAnestesia = async () => {
    return obterTiposAnestesia()
      .then(response => setListaTiposAnestesia(response.data || []))
      .finally(() => {
        setLoadingTiposAnestesia(false)
      })
  }

  const carregarOPME = async () => {
    return obterListaOPME()
      .then(response => setListaOPME(response.data || []))
      .finally(() => {
        setLoadingOPME(false)
      })
    // return setListaOPME(mockOPME)
  }

  const carregarMedicosPorEspecialidades = async () => {
    if (especialidades?.length === 0) {
      return null
    }
    setLoadingMedicos(true)
    var especialidadesId = command.especialidades.map(e => e.id)
    var uf = !!command?.hospital?.grupo ? command?.hospital?.grupo : null

    return buscarPorEspecialidades(especialidadesId, uf)
      .then(response => setListaMedicos(response.data || []))
      .finally(() => {
        setLoadingMedicos(false)
      })
    // return setListaOPME(mockOPME)
  }

  const carregarEquipamentos = async () => {
    return obterEquipamentos()
      .then(response => {
        setListaEquipamentos(response.data || [])
      })
      .finally(() => {
        setLoadingEquipamentos(false)
      })
    // var mockEquipamentos = JSON.parse(
    //   '[{"id":"98fc1eb6-c1a6-41fc-83fa-cf4ca972da89","descricao":"ARTROSCÓPIO","detalhe":null,"grupo":null},{"id":"9579d028-0f5e-4e46-8cea-df01240b9c80","descricao":"BIISTURI","detalhe":null,"grupo":null},{"id":"10cf852f-5b6b-4ffd-b527-7b23a3548d07","descricao":"CISTOSCOPIO","detalhe":null,"grupo":null},{"id":"0c2b0449-099e-4205-a8e4-dfce75786bcc","descricao":"ESTERELIZADOR","detalhe":null,"grupo":null},{"id":"1f0b0cca-2b3d-4670-86d6-f7f7e80fd9b4","descricao":"FIXADOR DE CABEÇA (MAYFIED OU SUGITA)","detalhe":null,"grupo":null},{"id":"c923ca0e-1846-408d-8511-be35525722ff","descricao":"HEMODINÂMICA","detalhe":null,"grupo":null},{"id":"3959016e-b9f7-40bd-bff8-a02d87559725","descricao":"HEMODINÂMICA","detalhe":null,"grupo":null},{"id":"d8dd4104-d13d-4550-a032-8fff187bcd8a","descricao":"MAT TESTE","detalhe":null,"grupo":null},{"id":"34aa3046-b15c-40dc-aa40-34336cc52de3","descricao":"MATERIAL UPPER","detalhe":null,"grupo":null},{"id":"f096d732-8f3e-48ed-8714-21cf30e5e7cc","descricao":"MICROSCÓPIO","detalhe":null,"grupo":null},{"id":"c982a046-1a54-4e5d-8437-4b3751052994","descricao":"MICROSCÓPIO","detalhe":null,"grupo":null},{"id":"4f7c8afc-2d54-4792-906a-f26f236d9256","descricao":"PERFURADOR","detalhe":null,"grupo":null},{"id":"081ffe9e-670e-4873-9665-4373824084cb","descricao":"PINÇA BIPOLAR LAPAROSCÓPICA AVANÇADA","detalhe":null,"grupo":null},{"id":"8f6ebe17-edf4-44a6-96ac-da3a079ab9e5","descricao":"RADIOSCOPIA","detalhe":null,"grupo":null},{"id":"af9167e3-c774-48dd-92c5-3fc5cf550214","descricao":"RADIOSCOPIA (ARCO CIRÚRGICO)","detalhe":null,"grupo":null},{"id":"18544a97-c524-4189-9aee-b988c34ba91e","descricao":"RESSETOSCÓPIO PARA PRÓSTATA","detalhe":null,"grupo":null},{"id":"a2f1206c-555a-4403-8fa7-167634282b45","descricao":"ROBÔ DA VINCI","detalhe":null,"grupo":null},{"id":"325de35b-8a33-4d12-a07a-ef61f85d4071","descricao":"SUPORTE DE FIXAÇÃO CRANIANA (MAYFIELD OU EQUIVALENTE)","detalhe":null,"grupo":null},{"id":"532afb21-4ba1-4489-93b8-5a350d912c9c","descricao":"TORRE DE VÍDEO","detalhe":null,"grupo":null},{"id":"b0c28345-4e82-4fb9-8788-43fc9e389c42","descricao":"ULTRASSOM INTRAOPERATÓRIO","detalhe":null,"grupo":null},{"id":"ba293451-92ad-497d-8f3b-1e137bbef780","descricao":"URETEROSCÓPIO FLEXÍVEL,RÍGIDO E CISTOSCÓPIO","detalhe":null,"grupo":null},{"id":"b685045c-275a-4c05-827c-0bd3677c62f8","descricao":"URETEROSCÓPIO RÍGIDO","detalhe":null,"grupo":null}]'
    // )
    // return setListaEquipamentos(mockEquipamentos)
  }

  async function carregarMateriais() {
    return obterMateriais()
      .then(res => setListaMateriais(res.data || []))
      .catch(err => showNotificationErrorAPI(err))
  }

  async function obterTaxaOpme() {
    var localAtendimentoId = command.hospital?.id
    if (!localAtendimentoId) {
      return
    }

    return obterTaxaOpmePorLocalAtendimentoId(localAtendimentoId).then(res => {
      const id = query.get('idPacote')
      if (!id) {
        setValue('taxaOpme', (res.data || 0) * 100)
      }
    })
    // .catch(err => showNotificationErrorAPI(err))
  }

  async function obterFornecedoresOpme() {
    var localAtendimentoId = command.hospital?.id
    if (!localAtendimentoId) {
      return
    }

    return obterFornecedoresPorLocalAtendimentoId(
      localAtendimentoId
    ).then(res => setListaFornecedores(res.data))
    // .catch(err => showNotificationErrorAPI(err))
  }

  async function obterHorariosBaixoFluxo() {
    setHorariosBaixoFluxo(null)
    var localAtendimentoId = command.hospital?.id
    if (!localAtendimentoId) {
      return
    }

    return obterHorariosBaixoFluxoPorLocalAtendimentoId(localAtendimentoId)
      .then(res => setHorariosBaixoFluxo(res.data || null))
      .catch(() => setHorariosBaixoFluxo(null))
  }

  //#endregion
  useEffect(() => {
    if (command.hospital?.id) {
      obterTaxaOpme()
      obterFornecedoresOpme()
    }
    obterHorariosBaixoFluxo()
  }, [command.hospital])

  const onSubmit = async () => {
    setLoadingSubmit(true)

    let pacote = mapearPacoteParaRequest(
      command,
      possuiExpiracao,
      semAnestesia,
      possuiAnestesista
    )
    // const x = JSON.parse(JSON.stringify(mock)) as any
    // let pacote = mapearPacoteParaRequest(x as IPacoteInteligenteForm)
    return salvarPacoteInteligente(pacote)
      .then(response => {
        Swal.fire({
          title: 'Parabéns!',
          text: 'Pacote inteligente criado com sucesso.',
          icon: 'success',
          confirmButtonText: 'Continuar',
          willClose: () => {
            //Verifica se tem url de retorno
            if (query.has('returnUrl')) {
              const returnUrl = query.get('returnUrl')
              history.replace(
                `${returnUrl}?idPacote=${response.data}&descricaoPacote=${command.descricao}`
              )
              return
            }
            history.replace(
              `${SynRoutes.listagemPacotesOperacional}?tipo=inteligente`
            )
          }
        })
      })
      .catch(error => showNotificationErrorAPI(error))
      .finally(() => setLoadingSubmit(false))
  }

  const theme = useTheme()
  const ehXS = useMediaQuery(theme.breakpoints.down('xs'))

  //#region stepper
  const [activeStep, setActiveStep] = React.useState<Steps>(
    Steps.especialidades
  )

  useEffect(() => {
    edicaoPacoteLiberado()
  }, [pacote])

  useEffect(() => {
    window.scrollTo(0, 0)

    if (activeStep === Steps.medicos) {
      carregarMedicosPorEspecialidades()
    }
  }, [activeStep])

  // MIN = Minimum expected value
  // MAX = Maximium expected value
  // Function to normalise the values (MIN / MAX could be integrated)

  function edicaoPacoteLiberado() {
    ehPacoteLiberado = pacote?.status === 3
    return ehPacoteLiberado
  }

  let lastStep = obterStepsAtivos().length
  let normalise = value => ((value - 0) * 100) / (lastStep - 0)

  const handleNext = async () => {
    var indexAtual = obterStepAtual()
    var ativos = obterStepsAtivos()
    var stepAtual = ativos[indexAtual]

    var campos = stepAtual.validacao

    if (campos) {
      var valido = await validarEtapa(activeStep)
      const result = await trigger(campos)
      if (!result || !valido) {
        return
      }
    }

    setActiveStep(ativos[indexAtual + 1].step)
  }

  function obterStepsAtivos(): EtapaConfiguracao[] {
    let stepsAtivos = etapasFormulario.filter(step => step.ativo)
    return stepsAtivos
  }

  function obterStepAtual() {
    let stepsAtivos = obterStepsAtivos()
    let index = stepsAtivos.findIndex(step => step.step === activeStep)
    return index
  }

  async function validarEtapa(etapa) {
    var itemInvalido: any = false

    switch (etapa) {
      case Steps.opmeHospital:
        itemInvalido = command.opmesInclusos.find(
          i => !i.descricao?.replaceAll(' ', '')
        )
        if (!!itemInvalido) {
          Swal.fire(
            'Ops...',
            'Para continuar o item de OPME deve ser preenchido corretamente ou excluído.',
            'warning'
          )
        }
        return !itemInvalido
      case Steps.opmeExterno:
        itemInvalido = command.opmes.find(
          i => !i.descricao?.replaceAll(' ', '') || !i.fornecedor?.id
        )
        if (!!itemInvalido) {
          Swal.fire(
            'Ops...',
            'Para continuar o item de OPME deve ser preenchido corretamente ou excluído.',
            'warning'
          )
        }
        return !itemInvalido
      case Steps.materiais:
        itemInvalido = command.materiais.find(
          i => !i.descricao?.replaceAll(' ', '')
        )
        if (!!itemInvalido) {
          Swal.fire(
            'Ops...',
            'Para continuar o material deve ser preenchido corretamente ou excluído.',
            'warning'
          )
        }
        return !itemInvalido
      case Steps.internacoes:
        var valorInternacao = command.valoresInternacao.find(
          i => INTERNACAO.id === i.id
        )

        if (!!valorInternacao) {
          let itemValido = command.acomodacoes.find(i => i.ativo && i.padrao)
          if (!itemValido) {
            Swal.fire(
              'Ops...',
              'Para continuar deve ser preenchido pelo menos uma acomodação ativa e padrão.',
              'warning'
            )
          }
          return !!itemValido
        }
        return true
      case Steps.reservaSangue:
        itemInvalido = command.examesDuranteInternacao.find(
          i => !i.descricao?.replaceAll(' ', '')
        )
        if (!!itemInvalido) {
          Swal.fire(
            'Ops...',
            'Para continuar o exame deve ser preenchido corretamente ou excluído.',
            'warning'
          )
        }
        return !itemInvalido
      case Steps.anestesias:
        var qtdAnestesia = command?.tiposAnestesia?.length || 0

        if (qtdAnestesia <= 0 && !semAnestesia) {
          Swal.fire(
            'Ops...',
            'Para continuar deve informar as anestesias ou informar que não se aplica.',
            'warning'
          )
          return false
        }
        return true
      case Steps.dataExpiracao:
        if (possuiExpiracao) {
          return await trigger('dataExpiracao')
        }
        return true
        break
      default:
        return true
    }
  }

  const debugSteps = false

  const handleBackToStep = stepNumber => {
    let stepsAtivos = obterStepsAtivos()

    var indexAtual = obterStepAtual()

    if (!stepNumber && stepNumber !== 0) {
      setActiveStep(stepsAtivos[indexAtual - 1].step)
      return
    }

    if (debugSteps || !!ehEdicao || stepNumber < indexAtual) {
      if (stepsAtivos[stepNumber]) {
        setActiveStep(stepsAtivos[stepNumber].step)
      }
      return
    }
  }

  const getSteps = number => {
    const steps = []
    const stepIndexAtual = obterStepAtual()
    for (let index = 0; index < number; index++) {
      const podeClicar = debugSteps || !!ehEdicao || index < stepIndexAtual
      steps.push(
        <Step key={index}>
          <StepLabel
            style={{ cursor: podeClicar ? 'pointer' : 'default' }}
            StepIconComponent={v => StepIconSyn({ ...v, key: index + 1 })}
            onClick={() => handleBackToStep(index)}
          ></StepLabel>
          <StepContent></StepContent>
        </Step>
      )
    }
    return steps
  }

  function toggleSemAnestesia() {
    setValue('tiposAnestesia', [])
    setSemAnestesia(!semAnestesia)
    if (!semAnestesia) {
      setPossuiAnestesista(false)
    }
  }

  //#endregion
  // if (loading) {
  //   return (
  //     <Box textAlign="center">
  //       <CircularProgress />
  //       <div>Carregando...</div>
  //     </Box>
  //   )
  // }
  function mostrarCasoPacoteLiberadoEdicao() {
    return (
      <UBox mb={3} render={ehPacoteLiberado}>
        <Alert severity="warning">
          <b>Esta etapa não pode ser modificada!</b>
          <br />
          Etapa não pode ser modificada pois esse pacote já foi liberado para
          médicos.
          <br />
        </Alert>
      </UBox>
    )
  }

  const INTERNACAO = INTERNACOES.find(i => i.codigo === 'INT')

  const handlePendenciaChange = (etapa: string, possuiPendencia: boolean, comentario: string) => {
    const currentPendencias = command.pendencias || []
    const index = currentPendencias.findIndex(p => p.etapa === etapa)
    let updated = [...currentPendencias]
    if (index >= 0) {
      updated[index] = { etapa, possuiPendencia, comentario }
    } else {
      updated.push({ etapa, possuiPendencia, comentario })
    }
    setValue('pendencias', updated)
  }

  return (
    <>
      {(loading || isLoadingParceiro) && (
        <Box textAlign="center">
          <CircularProgress />
          <div>Carregando...</div>
        </Box>
      )}

      <Box
        component="main"
        hidden={loading}
        className={`fadeInTransition ${classes.container}`}
      // style={{ wordBreak: 'break-all' }}
      >
        <CssBaseline />
        {/* command: {JSON.stringify(command.equipamentos)} */}
        {/* command: {JSON.stringify(command.valoresInternacao)} */}
        {/* acomodacoes: {JSON.stringify(errors)} */}
        {/* command: {JSON.stringify(command.descontoCartao)}
        command: {JSON.stringify(command.propostaCartaoDesconto)}
        command: {JSON.stringify(propostaCartaoDesconto)} */}
        {/* <br /> */}
        {/* <br /> */}
        {/* erros: {JSON.stringify(errors)} */}
        {/* locais: {JSON.stringify(locais)} */}
        {/* command: {JSON.stringify(command.hospital)} */}
        {/* taxa: {JSON.stringify(command.taxaSyn)} */}
        {ehXS && !ajustePacote && (
          <LinearProgress
            variant="determinate"
            value={normalise(activeStep + 1)}
          />
        )}
        <Grid container>
          {!ehXS && !ajustePacote && (
            <Grid item xs={12} sm={1}>
              <Box mt={5} pt={2} ml={4}>
                <Stepper
                  connector={<StepConnectorSyn />}
                  activeStep={obterStepAtual()}
                  style={{ margin: 0, padding: 0, background: 'none' }}
                  orientation="vertical"
                >
                  {getSteps(lastStep)}
                </Stepper>
              </Box>
            </Grid>
          )}
          <Grid item xs={12} sm={ajustePacote ? 12 : 10}>
            <Box mt={ehXS ? 2 : 5} pt={ehXS ? 0 : 2} p={ehXS ? 2 : 0}>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className={classes.form}
                noValidate={true}
              >
                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.especialidades}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  isUpdate={!!ehEdicao}
                  textoTitulo={
                    'Para quais especialidades esse pacote ficará disponível?'
                  }
                >
                  {/* {mostrarCasoPacoteLiberadoEdicao()} */}
                  <Autocomplete
                    multiple
                    erro={errors}
                    name="especialidades"
                    label={'Especialidades'}
                    value={command.especialidades}
                    getOptionSelected={option =>
                      !!command?.especialidades.find(l => l.id === option.id)
                    }
                    options={especialidades}
                    loading={loadingEspecialidades}
                    showCheck
                    // disabled={ehPacoteLiberado}
                    closeOnSelect
                    showAddButton
                    getOptionLabel={option => option.descricao}
                    onChange={(event, newValue: ObjetoDescricaoGenerico[]) => {
                      handleItemValue(
                        'especialidades',
                        newValue as ObjetoDescricaoGenerico[]
                      )
                    }}
                    InputProps={{
                      autoComplete: 'new-password'
                    }}
                    id="autocomplete-especialidades-pacote"
                  />
                  <Alert severity="info">
                    Somente os médicos da(s) especialidade (s) selecionadas(s)
                    visualizarão o pacote.
                  </Alert>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.observacao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  isUpdate={!!ehEdicao}
                  textoTitulo="Deseja adicionar alguma observação ao pacote?"
                >
                  <TextField
                    erro={errors}
                    name="observacao"
                    placeholder="Observações adicionais"
                    label="Observações"
                    inputRef={register}
                    inputProps={{ maxLength: 5000 }}
                    multiline
                    rows={4}
                    id="input-observacao-pacote"
                  />
                  <Alert severity="info" style={{ marginTop: 2 }}>
                    Esta informação será exibida para o médico no momento que
                    estiver solicitando uma solicitação de orçamento baseado
                    nesse pacote.
                  </Alert>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.medicos}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  isUpdate={!!ehEdicao}
                  textoTitulo={
                    'O pacote poderá ser usado por todos os médicos?'
                  }
                >
                  {/* {mostrarCasoPacoteLiberadoEdicao()} */}
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ padding: '10px' }}>
                      <RadioGroup
                        onChange={handleRadiosPacotePublico}
                        value={command?.pacotePublico}
                      >
                        <FormControlLabel
                          // disabled={ehPacoteLiberado}
                          control={
                            <Radio
                              value={true}
                              color="primary"
                              name="pacotePublico"
                              id="radio-pacote-publico-true"
                            />
                          }
                          label="Sim, para todos os médicos"
                          id="label-pacote-publico-true"
                        />
                        <FormControlLabel
                          // disabled={ehPacoteLiberado}
                          control={
                            <Radio
                              value={false}
                              color="primary"
                              name="pacotePublico"
                              id="radio-pacote-publico-false"
                            />
                          }
                          label="Não, selecionar os médicos"
                          id="label-pacote-publico-false"
                        />
                      </RadioGroup>
                      <FormHelperText error={!!errors?.pacotePublico}>
                        {errors?.pacotePublico?.message}
                      </FormHelperText>
                    </Grid>
                  </Grid>

                  <UBox mt={2} render={command?.pacotePublico === false}>
                    <Typography variant="h6">
                      Informe para quais médicos o pacote estará disponível
                    </Typography>

                    <Autocomplete
                      multiple
                      erro={errors}
                      name="listaMedico"
                      label="Médicos"
                      value={command?.listaMedico}
                      // getOptionSelected={option =>
                      //   !!command?.listaMedico.find(l => l.id === option.id)
                      // }
                      options={listaMedicos}
                      loading={loadingMedicos}
                      showCheck
                      closeOnSelect
                      showAddButton
                      getOptionLabel={option => option.nome}
                      onChange={(event, newValue: ResumoMedicoResponse[]) => {
                        handleItemValue(
                          'listaMedico',
                          newValue as ResumoMedicoResponse[]
                        )
                      }}
                      getOptionSelected={option =>
                        !!command?.listaMedico.find(l => l.id === option.id)
                      }
                      InputProps={{
                        autoComplete: 'new-password'
                      }}
                      id="autocomplete-medicos-pacote"
                    />
                    <Alert severity="info">
                      Caso selecione algum médico, somente ele poderá acessar o
                      pacote
                    </Alert>
                  </UBox>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  isUpdate={!!ehEdicao}
                  show={activeStep === Steps.pacote}
                  showFinish={ajustePacote}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={'Qual o nome do pacote?'}
                >
                  <TextField
                    erro={errors}
                    name="descricao"
                    value={command.descricao}
                    placeholder="Digite o nome..."
                    label="Nome do pacote"
                    inputRef={register}
                    inputProps={{ maxLength: 100 }}
                    id="input-descricao-pacote"
                  />

                  <UBox mt={2}>
                    <Typography variant="h6">
                      Qual é o código principal do procedimento?
                    </Typography>
                  </UBox>

                  <AutocompleteProcedimentos
                    erro={errors}
                    name="procedimentos"
                    label="Procedimentos"
                    value={command.procedimentos}
                    options={ehXS ? [] : listaProcedimentos}
                    getOptionLabel={option =>
                      `${option.detalhe || ''} - ${option.descricao}`
                    }
                    handleValue={newValue => {
                      handleItemValue('procedimentos', newValue)
                    }}
                    onClickAddButton={texto =>
                      handleShowModalProcedimento(texto)
                    }
                    id="autocomplete-procedimentos-pacote"
                  />

                  <UBox mt={2}>
                    <Typography variant="h6">
                      Perguntar se paciente possui plano de saúde?
                    </Typography>
                  </UBox>
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ padding: '10px' }}>
                      <RadioGroup
                        style={{ flexDirection: 'row' }}
                        onChange={handleRadiosAprovacaoHospital}
                        value={command?.planoDeSaude}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              value={true}
                              color="primary"
                              name="planoDeSaude"
                              id="radio-plano-de-saude-true"
                            />
                          }
                          label="Sim"
                          id="label-plano-de-saude-true"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              value={false}
                              color="primary"
                              name="planoDeSaude"
                              id="radio-plano-de-saude-false"
                            />
                          }
                          label="Não"
                          id="label-plano-de-saude-false"
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </StepContentSyn>
                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  isUpdate={!!ehEdicao}
                  show={activeStep === Steps.seguro}
                  showFinish={ajustePacote}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={''}
                  large
                >
                  {/* ── Seção 1: Elegibilidade ── */}
                  <Box style={{ border: '1px solid #e0e0e0', borderRadius: 12, padding: '20px 24px', marginBottom: 20, background: '#fff' }}>
                    <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, paddingBottom: 14, borderBottom: '1px solid #f0f0f0' }}>
                      <Box style={{ width: 32, height: 32, flexShrink: 0, background: 'rgb(240, 253, 249)', borderRadius: '50%', padding: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src="/image/seguro/shield-check-svgrepo-com.svg" alt="shield" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      </Box>
                      <Typography variant="h6" style={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1rem' }}>
                        1. Elegibilidade do procedimento
                      </Typography>
                    </Box>

                    <Typography variant="body2" style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>
                      Este procedimento é elegível para Proteção Financeira?
                    </Typography>
                    <Typography variant="caption" style={{ color: '#666', display: 'block', marginBottom: 16, lineHeight: 1.5 }}>
                      Ao ativar esta opção, o paciente poderá receber a oferta de proteção financeira para intercorrências relacionadas ao procedimento, conforme as regras da cobertura.
                    </Typography>

                    <Grid container spacing={2}>
                      {/* Card SIM */}
                      <Grid item xs={12} sm={6}>
                        <Box
                          onClick={() => handleItemValue('aceitaSeguro', true)}
                          style={{
                            border: command?.aceitaSeguro === true ? '2px solid #1cc3a5' : '1px solid #e0e0e0',
                            borderRadius: 10,
                            padding: '16px',
                            cursor: 'pointer',
                            background: command?.aceitaSeguro === true ? '#f0fdf9' : '#fff',
                            position: 'relative',
                            minHeight: 90,
                            transition: 'all 0.15s ease'
                          }}
                          id="card-aceita-seguro-sim"
                        >
                          <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                            <Radio
                              checked={command?.aceitaSeguro === true}
                              value="true"
                              color="primary"
                              name="aceitaSeguro"
                              id="radio-aceita-seguro-true"
                              style={{ padding: 0, marginTop: 2, color: command?.aceitaSeguro === true ? '#1cc3a5' : undefined }}
                              onChange={() => handleItemValue('aceitaSeguro', true)}
                            />
                            <Box>
                              <Typography variant="body2" style={{ fontWeight: 700, color: '#1a1a2e' }}>
                                Sim, oferecer Proteção Financeira
                              </Typography>
                              <Typography variant="caption" style={{ color: '#555', lineHeight: 1.5 }}>
                                O paciente poderá receber a oferta após confirmar o procedimento.
                              </Typography>
                            </Box>
                          </Box>
                          {command?.aceitaSeguro === true && (
                            <Box style={{ position: 'absolute', top: 15, right: 5 }}>
                              <img src="/image/seguro/check-circle-svgrepo-com.svg" alt="selecionado" style={{ width: 25, height: 25, objectFit: 'contain' }} />
                            </Box>
                          )}
                        </Box>
                      </Grid>

                      {/* Card NÃO */}
                      <Grid item xs={12} sm={6}>
                        <Box
                          onClick={() => handleItemValue('aceitaSeguro', false)}
                          style={{
                            border: command?.aceitaSeguro === false ? '2px solid #1cc3a5' : '1px solid #e0e0e0',
                            borderRadius: 10,
                            padding: '16px',
                            cursor: 'pointer',
                            background: command?.aceitaSeguro === false ? '#f0fdf9' : '#fff',
                            position: 'relative',
                            minHeight: 90,
                            transition: 'all 0.15s ease'
                          }}
                          id="card-aceita-seguro-nao"
                        >
                          <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                            <Radio
                              checked={command?.aceitaSeguro === false}
                              value="false"
                              color="primary"
                              name="aceitaSeguro"
                              id="radio-aceita-seguro-false"
                              style={{ padding: 0, marginTop: 2, color: command?.aceitaSeguro === false ? '#1cc3a5' : undefined }}
                              onChange={() => handleItemValue('aceitaSeguro', false)}
                            />
                            <Box>
                              <Typography variant="body2" style={{ fontWeight: 700, color: '#1a1a2e' }}>
                                Não oferecer Proteção Financeira
                              </Typography>
                              <Typography variant="caption" style={{ color: '#555', lineHeight: 1.5 }}>
                                A oferta não será exibida para este procedimento.
                              </Typography>
                            </Box>
                          </Box>
                          {command?.aceitaSeguro === false && (
                            <Box style={{ position: 'absolute', top: 15, right: 5 }}>
                              <img src="/image/seguro/check-circle-svgrepo-com.svg" alt="selecionado" style={{ width: 25, height: 25, objectFit: 'contain', display: 'block' }} />
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                    <FormHelperText error={!!errors?.aceitaSeguro}>
                      {errors?.aceitaSeguro?.message}
                    </FormHelperText>
                  </Box>
                  <UBox render={command?.aceitaSeguro === true}>
                    <Box style={{ border: '1px solid #e0e0e0', borderRadius: 12, padding: '20px 24px', background: '#fff' }}>
                      <Box style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, paddingBottom: 14, borderBottom: '1px solid #f0f0f0' }}>
                        <Box style={{ width: 32, height: 32, flexShrink: 0, background: 'rgb(240, 253, 249)', borderRadius: '50%', padding: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img src="/image/seguro/group-filled-persons-svgrepo-com.svg" alt="regras" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        </Box>
                        <Typography variant="h6" style={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1rem' }}>
                          2. Regras de elegibilidade
                        </Typography>
                      </Box>

                      <Typography variant="body2" style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>
                        Faixa etária permitida para Proteção Financeira
                      </Typography>

                      <Alert severity="info" style={{ marginBottom: 16 }}>
                        A oferta será exibida apenas para pacientes dentro da faixa etária definida abaixo.
                      </Alert>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="caption" style={{ color: '#1a1a2e', display: 'block', marginBottom: 4 }}>
                            Idade mínima do paciente
                          </Typography>
                          <Box style={{ display: 'flex', alignItems: 'center', border: '1px solid #c8c8c8', borderRadius: 8, overflow: 'hidden' }}>
                            <input
                              type="number"
                              name="idadeMinimaSeguro"
                              ref={register}
                              id="input-idade-minima-seguro"
                              style={{ flex: 1, border: 'none', outline: 'none', padding: '12px 14px', fontSize: '1rem', background: 'transparent' }}
                            />
                            <Box style={{ padding: '0 12px', color: '#888', fontSize: '0.85rem', borderLeft: '1px solid #e0e0e0', height: '100%', display: 'flex', alignItems: 'center' }}>
                              anos
                            </Box>
                          </Box>
                          <FormHelperText error={!!errors?.idadeMinimaSeguro}>
                            {errors?.idadeMinimaSeguro?.message}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="caption" style={{ color: '#1a1a2e', display: 'block', marginBottom: 4 }}>
                            Idade máxima do paciente
                          </Typography>
                          <Box style={{ display: 'flex', alignItems: 'center', border: '1px solid #c8c8c8', borderRadius: 8, overflow: 'hidden' }}>
                            <input
                              type="number"
                              name="idadeMaximaSeguro"
                              ref={register}
                              id="input-idade-maxima-seguro"
                              style={{ flex: 1, border: 'none', outline: 'none', padding: '12px 14px', fontSize: '1rem', background: 'transparent' }}
                            />
                            <Box style={{ padding: '0 12px', color: '#888', fontSize: '0.85rem', borderLeft: '1px solid #e0e0e0', height: '100%', display: 'flex', alignItems: 'center' }}>
                              anos
                            </Box>
                          </Box>
                          <FormHelperText error={!!errors?.idadeMaximaSeguro}>
                            {errors?.idadeMaximaSeguro?.message}
                          </FormHelperText>
                        </Grid>
                      </Grid>

                      <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 14 }}>
                        <Typography variant="caption" style={{ color: '#888' }}>
                          Pacientes fora da faixa etária definida não visualizarão a oferta de Proteção Financeira.
                        </Typography>
                      </Box>
                    </Box>
                  </UBox>
                </StepContentSyn>

                {
                  //#region nova etapa 4
                }
                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.valorBase}
                  showFinish={ajustePacote}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={'Quanto custa o valor base do procedimento?'}
                >
                  <UBox mb={2}>
                    <FormControl
                      // className={styles.formControl2}
                      fullWidth
                      size="medium"
                      variant="outlined"
                    >
                      <CurrencyInput
                        fullWidth
                        erro={errors}
                        autoFocus
                        variant="outlined"
                        // size="small"
                        // margin="normal"
                        name="valorBase"
                        label="Valor base"
                        hiddenLabel
                        control={control}
                        type="tel"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onValueChange={value =>
                          handleChangeValor('valorBase', value)
                        }
                        value={command?.valorBase > 0 ? command?.valorBase : 0}
                        id="input-valor-base"
                      />
                      <FormHelperText error={!!errors?.valorBase}>
                        {errors?.valorBase?.message}
                      </FormHelperText>
                    </FormControl>
                    <Alert severity="info">
                      Valor base leva em conta todos os valores que estão
                      inclusos no pacote.
                    </Alert>
                  </UBox>
                  <UBox mt={4} hidden={ehHospital}>
                    <UBox my={2}>
                      <Typography variant="h6">
                        O pacote utilizará taxa de serviço personalizada?
                      </Typography>
                    </UBox>
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        {/* {JSON.stringify(command?.possuiTaxaSynPersonalizada)} */}
                        <RadioGroup
                          style={{ flexDirection: 'row' }}
                          onChange={handleRadiosTaxaSyn}
                          value={command?.possuiTaxaSynPersonalizada}
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                value={true}
                                color="primary"
                                name="possuiTaxaSynPersonalizada"
                                id="radio-possui-taxa-syn-true"
                              />
                            }
                            label="Sim"
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                value={false}
                                color="primary"
                                name="possuiTaxaSynPersonalizada"
                                id="radio-possui-taxa-syn-false"
                              />
                            }
                            label="Não"
                          />
                        </RadioGroup>
                      </Grid>
                      <UBox
                        component={Grid}
                        item
                        xs={12}
                        render={!!command.possuiTaxaSynPersonalizada}
                      >
                        <FormControl fullWidth size="medium" variant="outlined">
                          <CurrencyInput
                            fullWidth
                            hidePrefix
                            erro={errors}
                            autoFocus
                            variant="outlined"
                            name="valor"
                            label="Taxa da Syn em %"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            InputProps={{
                              endAdornment: <>%</>
                            }}
                            max={10000}
                            onValueChange={value =>
                              handleChangeValor('taxaSyn', value)
                            }
                            value={command?.taxaSyn || 0}
                            id="input-taxa-syn"
                          />
                          <FormHelperText error={!!errors?.taxaSyn}>
                            {errors?.taxaSyn?.message}
                          </FormHelperText>
                        </FormControl>
                        <UBox>
                          <Alert severity="info">
                            Taxa de serviço será aplicada apenas nas
                            solicitações originadas por esse pacote.
                          </Alert>
                        </UBox>
                      </UBox>
                    </Grid>
                  </UBox>
                </StepContentSyn>

                {
                  //#endregion
                }

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  isUpdate={!!ehEdicao}
                  show={activeStep === Steps.descontos}
                  showFinish={ajustePacote}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                >
                  <UBox mt={4}>
                    <UBox my={2}>
                      <Typography variant="h6">
                        O pacote estará disponível em Horários de baixo fluxo?
                      </Typography>
                    </UBox>
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        {/* {JSON.stringify(command?.propostaBaixoFluxo)} */}
                        <RadioGroup
                          style={{ flexDirection: 'row' }}
                          onChange={handleRadiosPropFinalSemana}
                          value={command?.propostaBaixoFluxo}
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                value={true}
                                color="primary"
                                name="propostaBaixoFluxo"
                                id="radio-proposta-final-semana-true"
                              />
                            }
                            label="Sim"
                            id="label-proposta-final-semana-true"
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                value={false}
                                color="primary"
                                name="propostaBaixoFluxo"
                                id="radio-proposta-final-semana-false"
                              />
                            }
                            label="Não"
                            id="label-proposta-final-semana-false"
                          />
                        </RadioGroup>
                      </Grid>
                      <UBox
                        component={Grid}
                        item
                        xs={12}
                        render={!!command.propostaBaixoFluxo}
                      >
                        <FormControl fullWidth size="medium" variant="outlined">
                          <CurrencyInput
                            fullWidth
                            erro={errors}
                            size="small"
                            variant="outlined"
                            name="descontoBaixoFluxo"
                            label="Valor de desconto"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            onValueChange={value =>
                              handleChangeValor('descontoBaixoFluxo', value)
                            }
                            value={command?.descontoBaixoFluxo || 0}
                            id="input-desconto-final-semana"
                          />
                        </FormControl>
                        <UBox>
                          {horariosBaixoFluxo?.trim() ? (
                            <Alert severity="info">
                              Desconto será aplicado apenas nos Horários de
                              Baixo Fluxo do hospital:
                              <br />
                              <span style={{ whiteSpace: 'pre-wrap' }}>
                                {horariosBaixoFluxo}
                              </span>
                            </Alert>
                          ) : (
                            <Alert severity="warning">
                              Horários de baixo fluxo não configurados para
                              este hospital. Procure um Super Admin SYN para
                              configurá-los antes de gerar propostas de baixo
                              fluxo.
                            </Alert>
                          )}
                        </UBox>
                      </UBox>
                    </Grid>
                  </UBox>

                  <UBox mt={4}>
                    <UBox my={2}>
                      <Typography variant="h6">
                        O pacote estará disponível para centro cirúrgico
                        ambulatorial?
                      </Typography>
                    </UBox>
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        {/* {JSON.stringify(command?.propostaCentroCirurgicoAmbulatorial)} */}
                        <RadioGroup
                          style={{ flexDirection: 'row' }}
                          onChange={handleRadiosPropCentroCirurgico}
                          value={command?.propostaCentroCirurgicoAmbulatorial}
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                value={true}
                                color="primary"
                                name="propostaCentroCirurgicoAmbulatorial"
                                id="radio-proposta-centro-cirurgico-ambulatorial-true"
                              />
                            }
                            label="Sim"
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                value={false}
                                color="primary"
                                name="propostaCentroCirurgicoAmbulatorial"
                                id="radio-proposta-centro-cirurgico-ambulatorial-false"
                              />
                            }
                            label="Não"
                          />
                        </RadioGroup>
                      </Grid>
                      <UBox
                        component={Grid}
                        item
                        xs={12}
                        render={!!command.propostaCentroCirurgicoAmbulatorial}
                      >
                        <FormControl fullWidth size="medium" variant="outlined">
                          <CurrencyInput
                            fullWidth
                            erro={errors}
                            size="small"
                            variant="outlined"
                            name="descontoCentroCirurgicoAmbulatorial"
                            label="Valor de desconto"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            onValueChange={value =>
                              handleChangeValor(
                                'descontoCentroCirurgicoAmbulatorial',
                                value
                              )
                            }
                            value={
                              command?.descontoCentroCirurgicoAmbulatorial || 0
                            }
                            id="input-desconto-centro-cirurgico"
                          />
                        </FormControl>
                        <UBox>
                          <Alert severity="info">
                            Desconto será aplicado apenas para centro cirúrgico
                            ambulatorial.
                          </Alert>
                        </UBox>
                      </UBox>
                    </Grid>
                  </UBox>

                  <UBox mt={4}>
                    <UBox my={2}>
                      <Typography variant="h6">
                        O pacote estará disponível para cartão de desconto?
                      </Typography>
                    </UBox>
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        {/* {JSON.stringify(command?.propostaBaixoFluxo)} */}
                        <RadioGroup
                          style={{ flexDirection: 'row' }}
                          onChange={handleRadiosPropCartaoDesconto}
                          value={command?.propostaCartaoDesconto}
                        >
                          <FormControlLabel
                            control={
                              <Radio
                                value={true}
                                color="primary"
                                name="propostaCartaoDesconto"
                                id="radio-proposta-cartao-desconto-true"
                              />
                            }
                            label="Sim"
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                value={false}
                                color="primary"
                                name="propostaCartaoDesconto"
                                id="radio-proposta-cartao-desconto-false"
                              />
                            }
                            label="Não"
                          />
                        </RadioGroup>
                      </Grid>
                      <UBox
                        component={Grid}
                        item
                        xs={12}
                        render={!!command.propostaCartaoDesconto}
                      >
                        <FormControl fullWidth size="medium" variant="outlined">
                          <CurrencyInput
                            fullWidth
                            erro={errors}
                            size="small"
                            variant="outlined"
                            name="descontoCartao"
                            label="Valor de desconto"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            onValueChange={value =>
                              handleChangeValor('descontoCartao', value)
                            }
                            value={command?.descontoCartao || 0}
                            id="input-desconto-cartao"
                          />
                        </FormControl>
                        <UBox>
                          <Alert severity="info">
                            Desconto será aplicado apenas para o cartão de
                            desconto.
                          </Alert>
                        </UBox>
                      </UBox>
                    </Grid>
                  </UBox>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  // large
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.opmeHospital}
                  // show={true}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Quais itens de OPME já estão inclusos no pacote e são fornecidos pelo hospital?'
                  }
                >
                  <Grid container spacing={0}>
                    <UBox>
                      <UBox>
                        <UBox>
                          <TabelaOpme
                            key={JSON.stringify(command?.opmesInclusos)}
                            incluso
                            fornecedores={listaFornecedores}
                            handleChange={(opmes, valido) => {
                              if (
                                JSON.stringify(opmes) !==
                                JSON.stringify(command.opmesInclusos)
                              ) {
                                handleItemValue('opmesInclusos', opmes)
                              }
                            }}
                            opmes={command.opmesInclusos || []}
                          />
                        </UBox>
                      </UBox>
                    </UBox>
                  </Grid>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  // large
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.opmeExterno}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Existem itens de OPME que não são fornecidos pelo hospital?'
                  }
                >
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ padding: '10px' }}>
                      <RadioGroup
                        style={{ flexDirection: 'row' }}
                        onChange={handleRadiosOpme}
                        value={command?.possuiOpmeTerceiro}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              value={true}
                              color="primary"
                              name="possuiOpmeTerceiro"
                              id="radio-possui-opme-terceiro-true"
                            />
                          }
                          label="Sim"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              value={false}
                              color="primary"
                              name="possuiOpmeTerceiro"
                              id="radio-possui-opme-terceiro-false"
                            />
                          }
                          label="Não"
                        />
                      </RadioGroup>
                    </Grid>
                    <UBox render={command?.possuiOpmeTerceiro === true}>
                      <UBox my={2}>
                        <Typography variant="h6">
                          Qual a taxa de OPME do Hospital para esse pacote?
                        </Typography>
                      </UBox>
                      <UBox>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={6}>
                            <FormControl
                              fullWidth
                              size="medium"
                              variant="outlined"
                            >
                              <CurrencyInput
                                fullWidth
                                hidePrefix
                                erro={errors}
                                autoFocus
                                size="small"
                                variant="outlined"
                                name="valor"
                                label="Taxa de OPME em %"
                                hiddenLabel
                                control={control}
                                type="tel"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                InputProps={{
                                  endAdornment: <>%</>
                                }}
                                max={10000}
                                onValueChange={value =>
                                  handleChangeValor('taxaOpme', value)
                                }
                                value={command?.taxaOpme || 0}
                                id="input-taxa-opme"
                              />
                              <FormHelperText error={!!errors?.taxaOpme}>
                                {errors?.taxaOpme?.message}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                          <Alert severity="info">
                            Taxa será aplicada apenas nas solicitações
                            originadas por esse pacote
                          </Alert>
                        </Grid>

                        <UBox mt={2}>
                          <Typography variant="h6">
                            Informe os itens de OPME
                          </Typography>
                        </UBox>

                        {/* <Grid item xs={12} sm={12}>
                          <UBox my={2}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={command?.medicoInformaOpme}
                                    onChange={(e, value) =>
                                      handleMedicoInformaOpme(
                                        !command?.medicoInformaOpme
                                      )
                                    }
                                    value="true"
                                  />
                                }
                                label="Itens serão informados pelo médico"
                              />
                            </FormGroup>
                            <Alert severity="info">
                              Ao marcar essa opção o pacote passará por um
                              processo de aprovação após o médico informar itens
                              de OPME.
                            </Alert>
                          </UBox>
                        </Grid> */}
                        <UBox render={!command.medicoInformaOpme}>
                          <TabelaOpme
                            key={'o' + command?.opmes?.length}
                            fornecedores={listaFornecedores}
                            handleChange={(opmes, valido) => {
                              if (
                                JSON.stringify(opmes) !==
                                JSON.stringify(command.opmes)
                              ) {
                                handleItemValue('opmes', opmes)
                              }
                            }}
                            opmes={
                              command.opmes || [
                                {
                                  descricao: '',
                                  quantidadeIncluso: 0,
                                  podeSubtrair: false,
                                  podeAcrescentar: false,
                                  quantidade: 0,
                                  fornecedor: null,
                                  hospitalFornece: false,
                                  valorUnitario: 0
                                }
                              ]
                            }
                          />
                        </UBox>
                      </UBox>
                    </UBox>
                  </Grid>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.anestesias}
                  hideBack={ajustePacote}
                  showFinish={ajustePacote}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Quais são os tipos de anestesia possíveis para esse procedimento?'
                  }
                >
                  <Alert severity="info">
                    Os tipos de anestesia selecionados servirão como opção de
                    escolha do médico solicitante.
                  </Alert>
                  <Typography style={{ margin: '20px 0 0' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={semAnestesia}
                            onChange={() => toggleSemAnestesia()}
                            id="checkbox-sem-anestesia-true"
                          />
                        }
                        label={
                          <Typography variant="body1">
                            Não se aplica (Procedimento sem anestesia)
                          </Typography>
                        }
                        id="label-sem-anestesia"
                      />
                    </FormGroup>
                  </Typography>

                  <UBox hidden={semAnestesia}>
                    <Autocomplete
                      multiple
                      erro={errors}
                      name="tiposAnestesia"
                      label="Tipos de anestesia"
                      loading={loadingTiposAnestesia}
                      options={listaTiposAnestesia}
                      value={command.tiposAnestesia}
                      getOptionSelected={option =>
                        !!command.tiposAnestesia.find(l => l.id === option.id)
                      }
                      showCheck
                      showAddButton
                      onClickAddButton={texto =>
                        handleShowModal(texto, 'tiposAnestesia')
                      }
                      getOptionLabel={option => option.descricao}
                      onChange={(
                        event,
                        newValue: ObjetoDescricaoGenericoValor[]
                      ) => {
                        let novalista = newValue.map(v => {
                          return {
                            ...v,
                            valor: !!v.valor ? v.valor : 0,
                            valorIncluso: false
                          }
                        })
                        handleItemValue('tiposAnestesia', novalista)
                      }}
                      id="autocomplete-tipos-anestesia"
                    />
                    <Grid container spacing={0}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        {!obrigatorioAnestesiaHospital && (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={possuiAnestesista}
                                  onChange={() => {
                                    setPossuiAnestesista(!possuiAnestesista)
                                  }}
                                  id="switch-possui-anestesista"
                                />
                              }
                              label={
                                <Typography variant="body1">
                                  Hospital tem anestesista para esse
                                  procedimento?
                                </Typography>
                              }
                            />
                          </FormGroup>
                        )}
                      </Grid>
                      <UBox
                        hidden={
                          !(
                            possuiAnestesista || obrigatorioAnestesiaHospital
                          ) || !command?.tiposAnestesia?.length
                        }
                      >
                        <Alert severity="info">
                          Informe se o valor já está incluso no valor base do
                          pacote ou valor cobrado para cada tipo de anestesia.
                        </Alert>
                        {command?.tiposAnestesia?.map((a, i) => (
                          <Grid key={i} container spacing={0}>
                            <Grid
                              item
                              xs={12}
                              sm={a.id === anestesiaLocalId ? 12 : 7}
                              style={{ padding: '10px' }}
                            >
                              <Typography variant="body1">
                                <b>{a?.descricao}</b>
                              </Typography>
                              <UBox render={a.id !== anestesiaLocalId}>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={a.valorIncluso}
                                        onChange={(e, value) => {
                                          let anestesias =
                                            command.tiposAnestesia
                                          let indexA = anestesias.findIndex(
                                            e => e.descricao === a.descricao
                                          )
                                          if (value) {
                                            anestesias[indexA].valor = 0
                                          }
                                          anestesias[
                                            indexA
                                          ].valorIncluso = value

                                          handleItemValue(
                                            'tiposAnestesia',
                                            anestesias
                                          )
                                        }}
                                        id={`checkbox-valor-incluso-anestesia-${a?.id}`}
                                      />
                                    }
                                    label="valor incluso no pacote"
                                    id={`label-valor-incluso-anestesia-${a?.id}`}
                                  />
                                </FormGroup>
                              </UBox>
                              <UBox render={a.id === anestesiaLocalId}>
                                <Alert severity="info">
                                  Anestesia local é responsabilidade da equipe
                                  médica.
                                </Alert>
                              </UBox>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              sm={5}
                              style={{ padding: '10px' }}
                            >
                              <UBox
                                render={
                                  a.id !== anestesiaLocalId && !a.valorIncluso
                                }
                              >
                                <FormControl
                                  // className={styles.formControl2}
                                  fullWidth
                                  size="medium"
                                  variant="outlined"
                                >
                                  <CurrencyInput
                                    fullWidth
                                    // hidePrefix
                                    erro={errors}
                                    // autoFocus
                                    size="small"
                                    variant="outlined"
                                    // margin="normal"
                                    name="valorAnestesia"
                                    label="Valor"
                                    hiddenLabel
                                    control={control}
                                    type="tel"
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    // InputProps={{
                                    //   endAdornment: <>%</>
                                    // }}
                                    // max={10000}
                                    onValueChange={value =>
                                      handleChangeValorAnestesia(i, value)
                                    }
                                    value={a.valor || 0}
                                    id={`input-valor-anestesia-${i}`}
                                  />
                                  {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                                </FormControl>
                              </UBox>
                            </Grid>

                            <Grid item xs={12}>
                              <Divider />
                            </Grid>
                          </Grid>
                        ))}
                      </UBox>
                    </Grid>
                  </UBox>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  large
                  show={activeStep === Steps.equipamentos}
                  hideBack={ajustePacote}
                  showFinish={ajustePacote}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Caso o pacote necessite de algum equipamento, informe abaixo:'
                  }
                >
                  <UBox mt={2} mb={2}>
                    <Typography variant="body1">
                      <b>Equipamentos:</b>
                    </Typography>
                  </UBox>
                  <Grid container spacing={0}>
                    {listaEquipamentos.map((equipamento, i) => (
                      <Grid key={i} container spacing={0}>
                        <Grid
                          item
                          xs={12}
                          sm={5}
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                        >
                          <UBox width="36px">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    //   disabled={submitting || !!dadosBancarioId}
                                    checked={
                                      !!command?.equipamentos.find(
                                        e => equipamento?.id === e?.id
                                      )
                                    }
                                    onChange={(e, value) =>
                                      handleItemValueEquipamentos(equipamento)
                                    }
                                    value={equipamento.id}
                                    id={`checkbox-equipamento-${equipamento?.id}`}
                                  />
                                }
                                label=""
                              />
                            </FormGroup>
                          </UBox>
                          <Typography variant="body1">
                            {equipamento?.descricao}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <UBox
                            render={
                              !!obterEquipamentoSelecionadoPorId(
                                equipamento?.id
                              )
                            }
                          >
                            {/* {equipamento?.id} */}
                            {/* {JSON.stringify(
                              obterEquipamentoSelecionadoPorId(equipamento?.id)
                            )} */}
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    //   disabled={submitting || !!dadosBancarioId}
                                    checked={
                                      !!obterEquipamentoSelecionadoPorId(
                                        equipamento?.id
                                      )?.valorIncluso
                                    }
                                    onChange={
                                      (e, value) =>
                                        handleChangeItemValueEquipamento(
                                          obterEquipamentoSelecionadoPorId(
                                            equipamento?.id
                                          ),
                                          'valorIncluso',
                                          !obterEquipamentoSelecionadoPorId(
                                            equipamento?.id
                                          )?.valorIncluso
                                        )
                                      // handleItemValue('hospitalFornece', value)
                                    }
                                  // value={
                                  //   command?.equipamentos.find(
                                  //     e => equipamento?.id === e?.id
                                  //   )?.valorIncluso
                                  // }
                                  />
                                }
                                label={
                                  <Typography variant="body2">
                                    <small>Valor incluso no hospital</small>
                                  </Typography>
                                }
                                id={`checkbox-valor-incluso-equipamento-${equipamento?.id}`}
                              />
                            </FormGroup>
                          </UBox>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <UBox
                            render={
                              obterEquipamentoSelecionadoPorId(equipamento?.id)
                                ?.valorIncluso === false
                            }
                          >
                            <FormControl
                              // className={styles.formControl2}
                              fullWidth
                              size="medium"
                              variant="outlined"
                            >
                              <CurrencyInput
                                fullWidth
                                // hidePrefix
                                erro={errors}
                                // autoFocus
                                size="small"
                                variant="outlined"
                                // margin="normal"
                                name="valorAnestesia"
                                label="Valor"
                                hiddenLabel
                                control={control}
                                type="tel"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                // InputProps={{
                                //   endAdornment: <>%</>
                                // }}
                                // max={10000}
                                onValueChange={value =>
                                  handleChangeItemValueEquipamento(
                                    obterEquipamentoSelecionadoPorId(
                                      equipamento?.id
                                    ),
                                    'valor',
                                    value
                                  )
                                }
                                value={
                                  obterEquipamentoSelecionadoPorId(
                                    equipamento?.id
                                  )?.valor || equipamento.valor
                                }
                                id={`input-valor-equipamento-${i}`}
                              />
                              {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                            </FormControl>
                          </UBox>
                        </Grid>
                        <Grid item xs={12}>
                          <UBox my={1}>
                            <Divider />
                          </UBox>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.materiais}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'O pacote possui algum tipo de material específico?'
                  }
                >
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ padding: '10px' }}>
                      <RadioGroup
                        style={{ flexDirection: 'row' }}
                        onChange={handleRadiosMaterial}
                        value={command?.possuiMaterial}
                        id="radio-group-possui-material"
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              value={true}
                              color="primary"
                              name="possuiMaterial"
                              id="radio-possui-material-true"
                            />
                          }
                          label="Sim"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              value={false}
                              color="primary"
                              name="possuiMaterial"
                              id="radio-possui-material-false"
                            />
                          }
                          label="Não"
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <UBox render={command?.possuiMaterial === true}>
                    <UBox my={2}>
                      <Typography variant="h6">
                        Informe os materiais:
                      </Typography>
                    </UBox>
                    <UBox>
                      <TabelaMaterial
                        key={'m' + command?.materiais?.length}
                        incluso
                        handleChange={(materiais, valido) => {
                          if (
                            JSON.stringify(materiais) !==
                            JSON.stringify(command.materiais)
                          ) {
                            handleItemValue('materiais', materiais)
                          }
                        }}
                        materiais={
                          command.materiais || [
                            {
                              descricao: '',
                              valorUnitario: 0,
                              podeAcrescentar: false,
                              podeSubtrair: false,
                              quantidadeIncluso: 0
                            }
                          ]
                        }
                      />
                    </UBox>
                  </UBox>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  large
                  show={activeStep === Steps.internacoes}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Informe o valor do tipo de cada internação que pode ser aplicada à esse procedimento:'
                  }
                >
                  <Grid
                    key={'i' + command?.valoresInternacao?.length}
                    container
                    spacing={0}
                  >
                    {INTERNACOES.filter(i => i.tipo === 'U').map(
                      (internacao, i) => (
                        <Grid key={i} container spacing={0}>
                          <Grid
                            item
                            xs={12}
                            sm={5}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <UBox style={{ paddingLeft: 12 }}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        !!command?.valoresInternacao.find(
                                          e => internacao?.id === e?.id
                                        )
                                      }
                                      onChange={(e, value) =>
                                        handleItemValueInternacao(internacao)
                                      }
                                      id={`switch-internacao-${i}`}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      style={{
                                        color: !!command?.valoresInternacao.find(
                                          e => internacao?.id === e?.id
                                        )
                                          ? '#373737'
                                          : '#999'
                                      }}
                                    >
                                      <b>{internacao?.descricao}</b>
                                    </Typography>
                                  }
                                />
                              </FormGroup>
                            </UBox>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <UBox
                              render={
                                !!obterInternacaoSelecionadaPorId(
                                  internacao?.id
                                )
                              }
                            >
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      checked={
                                        !!command?.valoresInternacao.find(
                                          e =>
                                            internacao?.id === e?.id &&
                                            e?.valorIncluso
                                        )
                                      }
                                      onChange={(e, value) =>
                                        handleItemKeyInternacao(
                                          internacao,
                                          value,
                                          'valorIncluso'
                                        )
                                      }
                                      value={internacao.id}
                                      id={`checkbox-valor-incluso-internacao-${internacao?.id}`}
                                    />
                                  }
                                  label="valor incluso"
                                />
                              </FormGroup>
                            </UBox>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <UBox
                              render={
                                !!obterInternacaoSelecionadaPorId(
                                  internacao?.id
                                ) &&
                                !obterInternacaoSelecionadaPorId(internacao?.id)
                                  .valorIncluso
                              }
                            >
                              <FormControl
                                // className={styles.formControl2}
                                fullWidth
                                size="medium"
                                variant="outlined"
                              >
                                <CurrencyInput
                                  fullWidth
                                  // hidePrefix
                                  erro={errors}
                                  size="small"
                                  variant="outlined"
                                  name="valorAnestesia"
                                  label="Valor"
                                  hiddenLabel
                                  control={control}
                                  type="tel"
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  onValueChange={value =>
                                    handleChangeItemValueInternacao(
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      ),
                                      'valor',
                                      value
                                    )
                                  }
                                  value={
                                    obterInternacaoSelecionadaPorId(
                                      internacao?.id
                                    )?.valor || 0
                                  }
                                />
                                {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                              </FormControl>
                            </UBox>
                          </Grid>

                          <Grid item xs={12}>
                            <UBox my={1}>
                              <Divider />
                            </UBox>
                          </Grid>
                        </Grid>
                      )
                    )}
                  </Grid>
                  <UBox mt={2} mb={2}>
                    <Typography variant="body1">
                      <b>Unidades de internação com diárias:</b>
                    </Typography>
                  </UBox>
                  <UBox mb={3} mt={2}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center'
                        }}
                      >
                        <UBox style={{ paddingLeft: 12 }}>
                          {/* {JSON.stringify(
                                command?.valoresInternacao.find(
                                  e => internacao?.id === e?.id
                                )
                              )} */}
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={
                                    !!command?.valoresInternacao.find(
                                      e => INTERNACAO?.id === e?.id
                                    )
                                  }
                                  onChange={(e, value) =>
                                    handleItemValueInternacao(INTERNACAO)
                                  }
                                  id={`switch-internacao-${INTERNACAO?.id}`}
                                />
                              }
                              label={
                                <Typography
                                  variant="body1"
                                  style={{
                                    color: !!command?.valoresInternacao.find(
                                      e => INTERNACAO?.id === e?.id
                                    )
                                      ? '#373737'
                                      : '#999'
                                  }}
                                >
                                  <b>{INTERNACAO?.descricao}</b>
                                </Typography>
                              }
                            />
                          </FormGroup>
                        </UBox>
                      </Grid>
                      <UBox
                        component={Grid}
                        item
                        xs={12}
                        sm={3}
                        render={
                          !!obterInternacaoSelecionadaPorId(INTERNACAO?.id)
                        }
                      >
                        <FormControl
                          // className={styles.formControl2}
                          fullWidth
                          size="medium"
                          variant="outlined"
                        >
                          <CurrencyInput
                            fullWidth
                            size="small"
                            noMoney
                            erro={errors}
                            //   autoFocus
                            variant="outlined"
                            // margin="normal"
                            name="quantidade"
                            label="Diárias inclusas"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            // InputProps={{
                            //   endAdornment: <>%</>
                            // }}
                            // max={100000}
                            onValueChange={
                              value =>
                                handleItemKeyInternacao(
                                  INTERNACAO,
                                  value,
                                  'quantidadeIncluso'
                                )
                              //handleChangeValor('quantidadeIncluso', value)
                            }
                            value={
                              obterInternacaoSelecionadaPorId(INTERNACAO.id)
                                ?.quantidadeIncluso || 0
                            }
                            id="input-diarias-inclusas"
                          />
                        </FormControl>
                      </UBox>
                    </Grid>
                    <UBox
                      render={!!obterInternacaoSelecionadaPorId(INTERNACAO?.id)}
                    >
                      {/* a:{JSON.stringify(acomodacoes)}
                      <br />
                      commanda:{JSON.stringify(command.acomodacoes)} */}
                      <Typography variant="subtitle2">Acomodações:</Typography>
                      <TabelaAcomodacao
                        key={JSON.stringify(acomodacoes)}
                        handleChange={(novaLista, valido) => {
                          handleItemValue('acomodacoes', novaLista)
                        }}
                        acomodacoes={command.acomodacoes || []}
                      />
                      <br />
                      <Divider />
                    </UBox>
                  </UBox>
                  <Grid
                    key={'id' + command?.valoresInternacao?.length}
                    container
                    spacing={0}
                  >
                    {INTERNACOES.filter(i => i.tipo === 'D').map(
                      (internacao, i) => (
                        <Grid key={i} container spacing={1}>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <UBox style={{ paddingLeft: 12 }}>
                              {/* {JSON.stringify(
                                command?.valoresInternacao.find(
                                  e => internacao?.id === e?.id
                                )
                              )} */}
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={
                                        !!command?.valoresInternacao.find(
                                          e => internacao?.id === e?.id
                                        )
                                      }
                                      onChange={(e, value) =>
                                        handleItemValueInternacao(internacao)
                                      }
                                      id={`switch-internacao-${internacao?.id}`}
                                    />
                                  }
                                  label={
                                    <Typography
                                      variant="body1"
                                      style={{
                                        color: !!command?.valoresInternacao.find(
                                          e => internacao?.id === e?.id
                                        )
                                          ? '#373737'
                                          : '#999'
                                      }}
                                    >
                                      <b>{internacao?.descricao}</b>
                                    </Typography>
                                  }
                                />
                              </FormGroup>
                            </UBox>
                          </Grid>
                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={3}
                            render={
                              !!obterInternacaoSelecionadaPorId(internacao?.id)
                            }
                          >
                            <FormControl
                              // className={styles.formControl2}
                              fullWidth
                              size="medium"
                              variant="outlined"
                            >
                              <CurrencyInput
                                fullWidth
                                size="small"
                                noMoney
                                erro={errors}
                                //   autoFocus
                                variant="outlined"
                                // margin="normal"
                                name="quantidade"
                                label="Diárias inclusas"
                                hiddenLabel
                                control={control}
                                type="tel"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                // InputProps={{
                                //   endAdornment: <>%</>
                                // }}
                                // max={100000}
                                onValueChange={
                                  value =>
                                    handleItemKeyInternacao(
                                      internacao,
                                      value,
                                      'quantidadeIncluso'
                                    )

                                  // handleChangeValor('quantidadeIncluso', value)
                                }
                                value={
                                  obterInternacaoSelecionadaPorId(internacao.id)
                                    ?.quantidadeIncluso || 0
                                }
                                id={`input-diarias-inclusas-${i}`}
                              />
                            </FormControl>
                          </UBox>

                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={6}
                            pl={2}
                            style={{ display: 'flex', alignItems: 'center' }}
                            render={
                              !!internacao.ehInternacao &&
                              !!obterInternacaoSelecionadaPorId(internacao?.id)
                            }
                          >
                            <RadioGroup
                              style={{ flexDirection: 'row' }}
                              onChange={(e, value) =>
                                handleItemKeyInternacao(
                                  internacao,
                                  value === 'true',
                                  'apartamento'
                                )
                              }
                              value={
                                !!obterInternacaoSelecionadaPorId(
                                  internacao?.id
                                )?.apartamento
                              }
                            >
                              <FormControlLabel
                                control={
                                  <Radio
                                    value={false}
                                    color="primary"
                                    name="apartamento"
                                    id="radio-enfermaria"
                                  />
                                }
                                label="Enfermaria"
                              />
                              <FormControlLabel
                                control={
                                  <Radio
                                    value={true}
                                    color="primary"
                                    name="apartamento"
                                    id="radio-apartamento"
                                  />
                                }
                                label="Apartamento"
                              />
                            </RadioGroup>

                            {/* <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      obterInternacaoSelecionadaPorCodigo(
                                        internacao?.id
                                      )?.podeAcrescentar
                                    }
                                    onChange={(e, value) =>
                                      handleItemKeyInternacao(
                                        internacao,
                                        value,
                                        'podeAcrescentar'
                                      )
                                    }
                                    value={
                                      obterInternacaoSelecionadaPorCodigo(
                                        internacao?.id
                                      )?.podeAcrescentar
                                    }
                                  />
                                }
                                label="enfermaria"
                              />
                            </FormGroup>
                            */}
                          </UBox>

                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={3}
                            render={
                              !!internacao.ehInternacao &&
                              !!obterInternacaoSelecionadaPorId(internacao?.id)
                            }
                          >
                            <FormControl
                              // className={styles.formControl2}
                              fullWidth
                              size="medium"
                              variant="outlined"
                            >
                              <CurrencyInput
                                fullWidth
                                // hidePrefix
                                erro={errors}
                                margin="normal"
                                size="small"
                                variant="outlined"
                                name="valorAnestesia"
                                label="Valor enfermaria"
                                hiddenLabel
                                control={control}
                                type="tel"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                onValueChange={value =>
                                  handleChangeItemValueInternacao(
                                    obterInternacaoSelecionadaPorId(
                                      internacao?.id
                                    ),
                                    'valor',
                                    value
                                  )
                                }
                                value={
                                  obterInternacaoSelecionadaPorId(
                                    internacao?.id
                                  )?.valor || 0
                                }
                                id={`input-valor-enfermaria-${i}`}
                              />
                              {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                            </FormControl>
                          </UBox>
                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={3}
                            render={
                              !!internacao.ehInternacao &&
                              !!obterInternacaoSelecionadaPorId(internacao?.id)
                            }
                          >
                            <FormControl
                              // className={styles.formControl2}
                              fullWidth
                              size="medium"
                              variant="outlined"
                            >
                              <CurrencyInput
                                fullWidth
                                // hidePrefix
                                erro={errors}
                                margin="normal"
                                size="small"
                                variant="outlined"
                                name="valorApartamento"
                                label="Valor apartamento"
                                hiddenLabel
                                control={control}
                                type="tel"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                onValueChange={value =>
                                  handleChangeItemValueInternacao(
                                    obterInternacaoSelecionadaPorId(
                                      internacao?.id
                                    ),
                                    'valorApartamento',
                                    value
                                  )
                                }
                                value={
                                  obterInternacaoSelecionadaPorId(
                                    internacao?.id
                                  )?.valorApartamento || 0
                                }
                                id={`input-valor-apartamento-${i}`}
                              />
                              {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                            </FormControl>
                          </UBox>

                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={6}
                            pl={2}
                            style={{ display: 'flex', alignItems: 'center' }}
                            render={
                              !internacao?.ehInternacao &&
                              !!obterInternacaoSelecionadaPorId(internacao?.id)
                            }
                          >
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      )?.podeAcrescentar
                                    }
                                    onChange={(e, value) =>
                                      handleItemKeyInternacao(
                                        internacao,
                                        value,
                                        'podeAcrescentar'
                                      )
                                    }
                                    value={
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      )?.podeAcrescentar
                                    }
                                    id={`checkbox-pode-acrescentar-${internacao?.id}`}
                                  />
                                }
                                label="pode acrescentar"
                              />
                            </FormGroup>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      )?.podeSubtrair
                                    }
                                    onChange={(e, value) =>
                                      handleItemKeyInternacao(
                                        internacao,
                                        value,
                                        'podeSubtrair'
                                      )
                                    }
                                    value={
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      )?.podeSubtrair
                                    }
                                    id={`checkbox-pode-subtrair-${internacao?.id}`}
                                  />
                                }
                                label="pode subtrair"
                              />
                            </FormGroup>
                          </UBox>

                          <UBox
                            component={Grid}
                            item
                            xs={12}
                            sm={4}
                            render={!internacao.ehInternacao}
                          >
                            <UBox
                              render={
                                !!obterInternacaoSelecionadaPorId(
                                  internacao?.id
                                ) &&
                                (obterInternacaoSelecionadaPorId(internacao?.id)
                                  ?.podeAcrescentar ||
                                  obterInternacaoSelecionadaPorId(
                                    internacao?.id
                                  )?.podeSubtrair)
                              }
                            >
                              <FormControl
                                // className={styles.formControl2}
                                fullWidth
                                size="medium"
                                variant="outlined"
                              >
                                <CurrencyInput
                                  fullWidth
                                  // hidePrefix
                                  erro={errors}
                                  margin="normal"
                                  size="small"
                                  variant="outlined"
                                  name="valorAnestesia"
                                  label="Valor diária"
                                  hiddenLabel
                                  control={control}
                                  type="tel"
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  onValueChange={value =>
                                    handleChangeItemValueInternacao(
                                      obterInternacaoSelecionadaPorId(
                                        internacao?.id
                                      ),
                                      'valor',
                                      value
                                    )
                                  }
                                  value={
                                    obterInternacaoSelecionadaPorId(
                                      internacao?.id
                                    )?.valor || 0
                                  }
                                  id={`input-valor-diaria-${i}`}
                                />
                                {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                              </FormControl>
                            </UBox>
                          </UBox>

                          <Grid item xs={12}>
                            <UBox my={1}>
                              <Divider />
                            </UBox>
                          </Grid>
                        </Grid>
                      )
                    )}
                  </Grid>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  show={activeStep === Steps.dataExpiracao}
                  // show={true}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Os valores informados do pacote tem alguma data de expiração?'
                  }
                >
                  <Grid container spacing={0}>
                    <Grid item xs={12} style={{ padding: '10px' }}>
                      <RadioGroup
                        style={{ flexDirection: 'row' }}
                        onChange={handleRadiosExpiracao}
                        value={possuiExpiracao}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              value={true}
                              color="primary"
                              name="possuiOpme"
                              id="radio-possui-opme-true"
                            />
                          }
                          label="Sim"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              value={false}
                              color="primary"
                              name="possuiOpme"
                              id="radio-possui-opme-false"
                            />
                          }
                          label="Não"
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <UBox render={possuiExpiracao}>
                    <DateInput
                      errors={errors}
                      name="dataExpiracao"
                      label="Data de expiração"
                      value={command.dataExpiracao}
                      control={control}
                      handleChange={value =>
                        handleItemValue('dataExpiracao', value)
                      }
                    />
                    <Box mb={3}>
                      <Alert severity="warning">
                        Caso a data acima seja preenchida, após a data de
                        expiração o pacote será desativado para uso até ser
                        renovado
                      </Alert>
                    </Box>
                  </UBox>
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  // show={true}
                  show={activeStep === Steps.reservaSangue}
                  isUpdate={!!ehEdicao}
                  handleBackToStep={handleBackToStep}
                  handleNext={handleNext}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={'Itens adicionais do pacote'}
                >
                  <UBox>
                    <Typography variant="h6">
                      Utiliza reserva de sangue?
                    </Typography>
                    <RadioGroup
                      style={{ flexDirection: 'row' }}
                      onChange={handleRadiosSangue}
                      value={command?.possuiSangue}
                    >
                      <FormControlLabel
                        control={
                          <Radio
                            value={true}
                            color="primary"
                            name="possuiSangue"
                            id="radio-possui-sangue-true"
                          />
                        }
                        label="Sim"
                      />
                      <FormControlLabel
                        control={
                          <Radio
                            value={false}
                            color="primary"
                            name="possuiSangue"
                            id="radio-possui-sangue-false"
                          />
                        }
                        label="Não"
                      />
                    </RadioGroup>
                  </UBox>
                  <UBox mb={2} render={!!command?.possuiSangue}>
                    <Grid container spacing={0}>
                      <Grid item xs={12} sm={7} style={{ padding: '10px' }}>
                        <Typography variant="body1">
                          Taxa de reserva de sangue
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={5} style={{ padding: '10px' }}>
                        <FormControl
                          // className={styles.formControl2}
                          fullWidth
                          size="medium"
                          variant="outlined"
                        >
                          <CurrencyInput
                            fullWidth
                            // hidePrefix
                            erro={errors}
                            // autoFocus
                            size="small"
                            variant="outlined"
                            name="valorTaxaReservaSangue"
                            label="Valor"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            onValueChange={value =>
                              handleChangeValor('valorTaxaReservaSangue', value)
                            }
                            value={command?.valorTaxaReservaSangue || 0}
                            id="input-taxa-reserva-sangue"
                          />
                          {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container spacing={0}>
                      <Grid item xs={12} sm={7} style={{ padding: '10px' }}>
                        <Typography variant="body1">
                          Unidade de concentrados de hemácias
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={5} style={{ padding: '10px' }}>
                        <FormControl
                          // className={styles.formControl2}
                          fullWidth
                          size="medium"
                          variant="outlined"
                        >
                          <CurrencyInput
                            fullWidth
                            // hidePrefix
                            erro={errors}
                            // autoFocus
                            size="small"
                            variant="outlined"
                            name="valorUnidadeConcentradoHemacias"
                            label="Valor"
                            hiddenLabel
                            control={control}
                            type="tel"
                            InputLabelProps={{
                              shrink: true
                            }}
                            onValueChange={value =>
                              handleChangeValor(
                                'valorUnidadeConcentradoHemacias',
                                value
                              )
                            }
                            value={
                              command?.valorUnidadeConcentradoHemacias || 0
                            }
                            id="input-valor-unidade-hemacias"
                          />
                          {/* <FormHelperText error={!!errors?.taxaOpme}>
                              {errors?.taxaOpme?.message}
                            </FormHelperText> */}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </UBox>
                  <UBox mt={3}>
                    <Typography variant="h6">
                      Exames durante a internação:
                    </Typography>
                  </UBox>
                  <TabelaExame
                    key={'m' + command?.examesDuranteInternacao?.length}
                    incluso
                    handleChange={(exames, valido) => {
                      if (
                        JSON.stringify(exames) !==
                        JSON.stringify(command.examesDuranteInternacao)
                      ) {
                        handleItemValue('examesDuranteInternacao', exames)
                      }
                    }}
                    materiais={command?.examesDuranteInternacao || []}
                  />
                </StepContentSyn>

                <StepContentSyn
                  onPendenciaChange={handlePendenciaChange}
                  pendencias={command?.pendencias}
                  activeStep={activeStep}
                  lastStep={lastStep}
                  // show={true}
                  show={activeStep === Steps.revisao}
                  hideBack={false}
                  handleBackToStep={handleBackToStep}
                  handleFinish={() => {
                    onSubmit()
                  }}
                  textoTitulo={
                    'Ótimo! Agora revise as informações com ATENÇÃO antes de salvar'
                  }
                  showFinish
                  loading={loadingSubmit}
                >
                  <Box mb={3}>
                    <Typography variant="subtitle1">
                      Caso precise alterar alguma informação, clique no botão
                      'Voltar' até chegar na etapa desejada.
                    </Typography>
                  </Box>
                  {/* <UBox>c{JSON.stringify(command)}</UBox> */}
                  {command.observacao && (
                    <Box mb={2}>
                      <Typography variant="h6">Observação</Typography>
                      <Typography variant="body1">
                        {command.observacao}
                      </Typography>
                      <Divider style={{ margin: '12px 0' }} />
                    </Box>
                  )}
                  <ResumoPacoteInteligenteOps
                    adaptarValor={true}
                    exibirValor={true}
                    // medico={medico}
                    // selecionado={selecionado}
                    // esconderIncluso={esconderInclusos}
                    // exibirDadosMedicos={configurado}
                    pacote={{ ...command, possuiAnestesista, semAnestesia }}
                  // pacote={mock}
                  />
                </StepContentSyn>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default FormPacoteInteligente
